window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
 
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      //debugger;
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateProductVariantTitlePrice(variant);
      this._updateBackInStockButton(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      //debugger;
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      } else {
        var slideIndex = $('[data-image-id="' + variant.featured_image.id +'"]').parents('.slick-slide').data('slick-index');
        
        $('.product__zoom .product-slider-gallery').slick('slickGoTo', parseInt(slideIndex));
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    },

    /**
     * Update product variant title & price
     * Custom function
     */
    _updateProductVariantTitlePrice: function(variant) {
      $('.product-variant-title').html(variant.title);
      $('.product-variant-price').html('$' + (variant.price / 100).toFixed(2) );
    },

    /**
     * Update "Back in Stock" button
     * Custom function
     */
    _updateBackInStockButton: function(variant) {
      $('#BIS_trigger').attr('data-variant-id', variant.id);
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartMobile: '#mobile-add-to-cart',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productSecondaryImage: '[data-product-secondary-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    variantSelector: '#variant-selector-wrapper__color > select, #variant-selector-wrapper__material > select',
    variantSelectorSpecial: '#variant-selector-wrapper__length > select',
    activeVariantItem: '#variant-selector-wrapper__color > select option:selected, #variant-selector-wrapper__material > select option:selected',
    activeVariantItemSpecial: '#variant-selector-wrapper__length > select option:selected'
  };

  var $case_size = $("#variant-selector-wrapper__case-size > select option:selected");
  if($case_size.length > 0){
    selectors.variantSelectorSpecial = '#variant-selector-wrapper__case-size > select';
    selectors.activeVariantItemSpecial = '#variant-selector-wrapper__case-size > select option:selected';
  }


  var $loader_image = $('#loader_img');

  var $selectors = {
    productGallerySlider: $('.product__zoom .product-slider-gallery'),
    productGallerySliderNav: $('.product__slider .product-slider-gallery-nav'),
    productLoadingImg: $loader_image,
    productGallerySliderChildren: '',
    productVideoLoadingImg: $loader_image.data("vidloading-image"),
    productVideoButtonWrap: $(".product__video-button-wrap")
  };

  var product_options = {
    is_video_init: false,
    is_gallery_firsttime_init: false
  };

  var swatch_product_options = {
    activeSwatchColor: '',
    image_data: [],
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      console.log("Stop loading Product");
      return;
    }
    else {
      console.log("Continue loading Product");
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if($selectors.productGallerySlider.hasClass('has-color-variants'))
    {
      this.has_color_variants = true;
    }
    else {
      this.has_color_variants = false;
    }

   /*
    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }*/

    this.init();
  }

  Product.prototype = $.extend({}, Product.prototype, {
    /* Init Chain
      initProductSwatchSystem()
      > updateMaterialTextMM()
      initSliders()
        > initSlidersSwatchPrep()
        > initProductVideoFunction()
    */
    init: function() {
      console.log("firing init product");
	  //debugger;
      if($(selectors.variantSelectorSpecial).length > 0){
        console.log("Exception variant mode enabled");
        selectors.variantSelector = selectors.variantSelectorSpecial;
        selectors.activeVariantItem = selectors.activeVariantItemSpecial;
      }

      if(this.has_color_variants){
        this.initProductSwatchSystem();
      }

      if ($.fn.slick) {
        this.initSliders();
      }
      else {
        setTimeout(function() {
            this.initSliders();
        }, 500);
      }

      this.initProductExtraFunc();

    },
    initProductExtraFunc: function() {
      var $selectorsCaseSize = $(".specification-table--detail--case-size");
      var $selectorsCaseThickness = $(".specification-table--detail--case-thickness");
      var $selectorsStrapWidth = $(".specification-table--detail--strap-width");

      $(".variant__list--case-size .variant__link").on('click', function(e) {
        var caseSize = $(this).data("value");
        $selectorsCaseSize.each(function() {
          $(this).text(caseSize);
        });

        var caseThickness = $(this).data("case-thickness");
        $selectorsCaseThickness.each(function() {
          $(this).text(caseThickness);
        });

        var strapWidth = $(this).data("strap-width");
        $selectorsStrapWidth.each(function() {
          $(this).text(strapWidth);
        });

      });
    },
    initProductSwatchSystem: function() {
      console.log("Product: Init Swatch System");
      //debugger;

      var $slides = $selectors.productGallerySlider.children('.product__img');
      var active_color = this.getActiveSwatchColor(false);
      this.setActiveSwatchColor(active_color);

      $slides.each(function( index ) {
        var image_max = $(this).data("image-max");
        var image_max_x2 = $(this).data("image-max-x2");
        var imageId = $(this).data("image-id");
        var thumb = $(this).data("thumb");
        var alt = $(this).data("alt");

        if(imageId in swatch_product_options.image_data){

        }
        else {
          swatch_product_options.image_data[ imageId ] = [];
        }
        //slide: $slide, 
        var idata = {image_max: image_max, image_max_x2: image_max_x2, imageId: imageId, thumb: thumb, alt: alt};

        swatch_product_options.image_data[ imageId ].push(idata);

//         if(imageId != active_color){
//           //$(this).remove();
//         } else {
//           if (alt.indexOf('featured-only') < 0) {
//             $selectors.productGallerySliderNav.append('<div class="product__thumb"><img src="'+thumb+'"></div>');
//           }
//         }
      });

      this.updateMaterialTextMM('');

    },

    initSliders: function() {
      var parent_ref = this;
      // On Slick
      console.log("Product: Init Sliders");
      if(this.has_color_variants)
      {
        this.initSlidersSwatchPrep();
      }

      $selectors.productGallerySlider.fadeIn(300).slick({
          //lazyLoad: "progressive",
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          fade: true,
         // asNavFor: '.product__slider .product-slider-gallery-nav'
      });

      $selectors.productGallerySlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        //debugger;
        console.log("PGS - beforeChange");
        var $slides = $selectors.productGallerySlider.slick("getSlick").$slides;
        var next_option = $slides.eq( nextSlide ).data("option");

        var curr_option = $slides.eq( currentSlide ).data("option");

        if (typeof next_option === 'undefined'){
          var next_option = $slides.eq( nextSlide ).find('.product__img').data("option");
          var curr_option = $slides.eq( currentSlide ).find('.product__img').data("option");
        }

        if(next_option == "video"){

          if(product_options.is_video_init){
            var $productVideo = $('.product__video');
            if($productVideo.length > 0)
            {
              var pvid = $productVideo[0];
              pvid.load();
              pvid.play();

            }
          }
          else {
            product_options.is_video_init = true;
            parent_ref.initProductVideoFunction();        
          }


        }
        else if(curr_option == "video")
        {
          var $productVideo = $('.product__video');
          if($productVideo.length > 0)
          {
            var pvid = $productVideo[0];
            //pvid.pause();
            //pvid.currentTime = 0;

          }
        }
      });


      /*
      $selectors.productGallerySliderNav.slick({
        //slidesToShow: $selectors.productGallerySliderNav.data('limit'),
        slidesToScroll: 1,
        asNavFor: '.product-slider-gallery',
        arrows: false,
        dots: false,
        draggable: false,
        infinite: false,
        centerMode: true,
        vertical: true,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 989,
            settings: {
              vertical: false
            }
          }
        ]
      });*/

      this.reslickGalleryNav();



      $selectors.productLoadingImg.fadeOut(100);

      if(this.has_color_variants)
      {
        this.registerSwatchHandlers();
      }



      if($(".product__video-button").length > 0)
      {
        $(".product__video-button").on('click', function(e){
            var $gslider = $selectors.productGallerySlider;
            var slide_count = $gslider.slick("getSlick").slideCount;
            $gslider.slick('slickGoTo', slide_count - 1);
        });
      }

    },
    reslickGalleryNav: function() {
      var $slider_nav_container = $(".product__slider");

      var $slider_nav = $slider_nav_container.find(".product-slider-gallery-nav");

      $slider_nav_container.imagesLoaded( function() {
        $slider_nav.slick({
          slidesToShow: $slider_nav_container.data('limit'),
          slidesToScroll: 1,
          asNavFor: '.product-slider-gallery',
          arrows: false,
          dots: false,
          draggable: false,
          infinite: false,
          vertical: true,
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 989,
              settings: {
                vertical: false
              }
            }
          ]
        });

        $slider_nav.slick('resize');


        $('.product-layout .product__slider .product-slider-gallery-nav').on('breakpoint', function(e){
          $('.product-layout .product__slider .product-slider-gallery-nav .slick-list').perfectScrollbar();
        });

        if(!product_options.is_gallery_firsttime_init){
          product_options.is_gallery_firsttime_init = true;
          $( window ).load(function() {
            console.log("Load perfect scrollbar");
            //$('.product-layout .product__slider .product-slider-gallery-nav .slick-list').perfectScrollbar(); 
          });
        }
        else {
          //$('.product-layout .product__slider .product-slider-gallery-nav .slick-list').perfectScrollbar(); 
        }


      });

                

    },
    reslickGalleryMain: function() {
     // var $slider_nav_container = $(".product__slider");

       // var $slider_nav = $slider_nav_container.find(".product-slider-gallery-nav");

        $selectors.productGallerySlider.imagesLoaded( function() {
          $selectors.productGallerySlider.slick({
              //lazyLoad: "progressive",
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              fade: true,
             // asNavFor: '.product__slider .product-slider-gallery-nav'
          });
        });

                

    },
    initSlidersSwatchPrep: function() {
      console.log("Product: Init Swatch Prep");

      var $slides = $selectors.productGallerySlider.children('.product__img');
      var $slide_nav = $selectors.productGallerySliderNav;

      var active_color = this.getActiveSwatchColor(true);

      $slides.each(function( index ) {
        var option = $(this).data("option");
        console.log("Option is: "+option+ " active_color is: "+active_color);

//         if (!$(this).hasClass('product__img--video')) {
//           if(option != active_color){
//             $(this).remove();
//           }              
//         }
//         if ($(this).hasClass('product__img--featured-only')) {
//           $(this).remove();
//         } 
      });

      $slide_nav.append($slide_nav.find('.product__thumb--video'));


    },
    registerSwatchHandlers: function() {
      var parent_ref = this;
	  //debugger;
      $(selectors.variantSelector).change(function() { 
        //debugger;
        var $optionSelected = $(this).find("option:selected");
        var variant_classvalue = $optionSelected.data("variant-classvalue");
        var $details_thumbnail = $('.product-details__thumbnail img');
        var active_color = parent_ref.getActiveSwatchColor(false);

        var $slider = $selectors.productGallerySlider;
        //var $slider_nav = $selectors.productGallerySliderNav;

        var $slider_nav_container = $(".product__slider");

        var $slider_nav = $slider_nav_container.find(".product-slider-gallery-nav");

        //$slider.slick("unslick");

        //$slider_nav.slick("unslick");
        //$slider_nav.remove();
        //$slider_nav_container.prepend('<div class="product-slider-gallery-nav"></div>');
        //var $slider_nav = $slider_nav_container.find(".product-slider-gallery-nav");
        //$selectors.productGallerySliderNav = $slider_nav;

        parent_ref.updateMaterialTextMM(active_color);
		//debugger;
        if(active_color in swatch_product_options.image_data)
        {
          var active_option_image_data = swatch_product_options.image_data[active_color];
          //$slider.slick('slickRemove', null, null, true);
          
          //$slider_nav.slick('slickRemove', null, null, true);

          $.each(active_option_image_data, function( index, value ) {
            if (value.alt.indexOf('featured') >= 0) {
              if (value.image_max_x2) {
                $details_thumbnail.attr('src', value.image_max ).attr('srcset', value.image_max+' 1x, '+value.image_max_x2+' 2x' );
              } else {
                $details_thumbnail.attr('src', value.image_max );
              }


                if (value.alt.indexOf('featured-only') < 0) {
                  if (value.image_max_x2) {
                    $slider.slick('slickAdd', '<div class="product__img"><img src="'+value.image_max+'" srcset=" '+value.image_max+' 1x, '+value.image_max_x2+' 2x"></div>');
                  } else {
                    $slider.slick('slickAdd', '<div class="product__img"><img src="'+value.image_max+'"></div>');
                  }

                  $slider_nav.append('<div class="product__thumb"><img src="'+value.thumb+'"></div>');
                }


            } else { 
              if (value.image_max_x2) {
                $slider.slick('slickAdd', '<div class="product__img"><img src="'+value.image_max+'" srcset=" '+value.image_max+' 1x, '+value.image_max_x2+' 2x"></div>');
              } else {
                $slider.slick('slickAdd', '<div class="product__img"><img src="'+value.image_max+'"></div>');
              }

              $slider_nav.append('<div class="product__thumb"><img src="'+value.thumb+'"></div>');

            }
          });

//           if("video" in swatch_product_options.image_data)
//           {
//             console.log("add Video");

//             var ctext_html = '';
//             var ctext = $selectors.productVideoButtonWrap.data("video-ctext");
//             if(ctext){
//               ctext_html = '<div class="product__img--video-ctext">'+ctext+'</div>';
//             }

//             $slider.slick('slickAdd', '<div class="product__img product__img--video" data-option="video"><div class="product__video-wrap"><video poster="'+$selectors.productVideoLoadingImg+'" class="product__video" controlsList="nodownload" autoplay loop muted playsinline disablePictureInPicture><source src="'+swatch_product_options.image_data['video'][0]['alt'].replace('video|', '')+'" type="video/mp4"></video></div>'+ctext_html+'</div>');
            
//             $slider_nav.append('<div class="product__thumb product__thumb--video"><i class="fa fa-play-circle"></i><img src="'+swatch_product_options.image_data['video'][0]['thumb']+'"></div>');
//             var $productVideo = $('.product__video');
//             if($productVideo.length > 0)
//             {
//               var pvid = $productVideo[0];
//               pvid.load();
//               parent_ref.setupVideoLoaderListener();
//               //pvid.pause();
//             }
//           }

          



          /*
          $slider_nav.slick('resize');

          setTimeout(function() {
            $slider_nav.find('.slick-list').height('100%');
            $slider_nav.find('.slick-track').height('100%');
              //slick-track
          }, 600); */
              

        } // end if(active_color in swatch_product_options.image_data)

        //parent_ref.reslickGalleryNav();
        

        //reslickGalleryMain

        //$(window).trigger('resize');
      });

    },

    initProductVideoFunction: function () {
      console.log("Init video");
      var $productVideoWrap = $('.product__video-wrap');
      if($productVideoWrap.length > 0)
      {
        var src = $productVideoWrap.data("src");
        $productVideoWrap.append('<video poster="'+$selectors.productVideoLoadingImg+'" class="product__video" controlsList="nodownload" autoplay loop muted playsinline disablePictureInPicture><source src="'+src+'" type="video/mp4"></video>');

        var pvid = $productVideoWrap.find('video');

        if(pvid.length > 0){
          pvid = pvid[0];
          pvid.load();
          //pvid.pause();   
        }

        this.setupVideoLoaderListener();



      }
    },
    setupVideoLoaderListener: function () {
      var $vidwrap = $('.product__video-wrap');
      var $video = $vidwrap.find('video');

        $video.on('loadstart', function (event) {
            console.log("Init video -- loadstart");
            $vidwrap.addClass('loading');
        });

        $video.on('canplay', function (event) {
            console.log("Init video -- canplay");
            //$('.product__video-wrap').removeClass('loading');
            //$(this).get(0).play();
        });

        $video.on("pause", function (e) {
          console.log("Init video -- pause");
          $vidwrap.removeClass('loading');
        });   

        $video.on("play", function (e) {
          console.log("Init video -- play");
          $vidwrap.removeClass('loading');
        });

        $video.on("playing", function (e) {
          console.log("Init video -- playing");
          $vidwrap.removeClass('loading');
        });
    },
    setActiveSwatchColor: function(color) {
      swatch_product_options.activeSwatchColor = color;
    },
    getActiveSwatchColor: function (return_global) {
      if(return_global)
      {
        return swatch_product_options.activeSwatchColor;
      }
      else {

        var $active_item = $(selectors.activeVariantItem);
        var active_color = $active_item.data('variant-sysvalue');
        return active_color;
      }
    },
    getActiveSwatchColorClass: function () {
      var $active_item = $(selectors.activeVariantItem);
      var active_color = $active_item.data('variant-classvalue');
      return active_color;
    },
    updateMaterialTextMM: function (active_color) {

      var $bwc_first = $(".bwc-first");
      var $bwc_last = $(".bwc-last");
      var $pd_pc_first = $(".pd-pc-first");

      if(!active_color){
        var active_color = this.getActiveSwatchColor(false);
      }

      var is_mm_site = $("body.site-moonmagic");

      if (typeof product_swatch_tags !== 'undefined' && is_mm_site.length > 0) {
        if(active_color in product_swatch_tags){
          var val = product_swatch_tags[active_color];
          $bwc_last.hide();

          if($bwc_first.length > 0){
            $bwc_first.each(function() {
              $(this).text(val);
            });
          }

          if($pd_pc_first.length > 0){
            $pd_pc_first.each(function() {
              if(val == '14kt Rose Gold Vermeil' || val == '14kt Yellow Gold Vermeil') {
                $(this).text("- " + val + ' *');
                $bwc_last.show();
              } else {
                $(this).text("- " + val);
              }
            });
          }

          
        }
      }
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartMobile, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }
      
      //debugger;

      if (variant.available) {
        if ( $('.klaviyo-bis-trigger').length > 0) {
          $(selectors.addToCart, this.$container).prop('disabled', false).show();
          $(selectors.addToCartMobile, this.$container).prop('disabled', false).show();
          $(selectors.addToCartText, this.$container).html(theme.strings.addToCart + ' >');
          $('.klaviyo-bis-trigger').hide();
        } else {
          $(selectors.addToCart, this.$container).prop('disabled', false);
          $(selectors.addToCartMobile, this.$container).prop('disabled', false);
          $(selectors.addToCartText, this.$container).html(theme.strings.addToCart + ' >');
        }
      } else {
        if ( $('.klaviyo-bis-trigger').length > 0 ) {
          $(selectors.addToCart, this.$container).hide();
          $(selectors.addToCartMobile, this.$container).hide();
          $('.klaviyo-bis-trigger').css({display:'inline-block'});
        } else {
          $(selectors.addToCart, this.$container).prop('disabled', true);
          $(selectors.addToCartMobile, this.$container).prop('disabled', true);          
          $('.button--mobile-cart span[data-add-to-cart-text]').html(theme.strings.soldOut + '<div class="BIS_custom" data-ref="out-of-stock-klaviyo"></div>');
          $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
        }
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);
      var salePercentAmount = Math.floor((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
      
      var additionalPrice = parseInt($('.product__price').attr('data-additional-price'));
      $('.product__price').attr('data-variant-price', variant.price);

      if($("body").hasClass("site-moonmagic")){
        this.updateEstimatedRetailerPrice(variant.price);
      }

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price + additionalPrice, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $comparePrice.next('.product__sale-amount').html('- ' + salePercentAmount + '%');
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $comparePrice.next('.product__sale-amount').html('');
        $compareEls.addClass('hide');
      }
    },
    updateEstimatedRetailerPrice: function(price) {
      //var test = slate.Currency.formatMoney(price, '{{amount}}');

      var amount = price / 100;
      var estprice = amount * 2.2;
      estprice = Math.round(estprice);

      var mod = estprice % 10;
      mod = 9 - mod;
      estprice = (estprice + mod) * 100;
      var $price_section = $(".usp-section--ppb-est-price");
      if($price_section.length > 0){
        var result = slate.Currency.formatMoney(estprice, theme.moneyFormat);
        result = result.replace(".00", "");
        $price_section.text(result);
      }

    },
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

theme.collections = (function() {


  var $collectionMain = $('#collection-main');

  if (!$collectionMain.length) {
    return;
  }

  // Collection Page

      var collectionPage = (function () {
        var $root = $$('html, body');
        var $collectionGrid = $$('#collection-grid');

        var $pagination = $$('#pagination');

        var collectionContainer = document.querySelector('[data-ref="collection-grid"]');
        var firstGap = document.querySelector('[data-ref="first-gap"]');

        var noProducts = document.querySelector('[data-ref="collection-no-products"]');

        var clearFilter = document.querySelector('[data-ref="collection-clear"]');

        // All current query strings - need to handle collection sort here.
        // This is probably unneeded when we can directly grab page etc - bit more clean this way tho
        var queryString = getRequests();

        // Get Current Page
        var current_page = 1;

        var ajaxQueryString = "?view=json";

        if(queryString["sort_by"] != undefined && queryString["sort_by"] != '')
        {

          if(queryString["sort_by"] == "manual" || queryString["sort_by"] == "best-selling" || queryString["sort_by"] == "title-ascending"
            || queryString["sort_by"] == "title-descending" || queryString["sort_by"] == "price-ascending" || queryString["sort_by"] == "price-descending"
            || queryString["sort_by"] == "created-descending" || queryString["sort_by"] == "created-ascending")
          {
            ajaxQueryString = ajaxQueryString + "&sort_by=" + encodeURIComponent(queryString["sort_by"]);
          }

        }

        if(queryString["page"] != undefined && queryString["page"] != '')
        {
          current_page = parseInt(queryString["page"]);
          if(isNaN(current_page))
          {
            current_page = 1;
          }
          //ajaxQueryString = ajaxQueryString + "&page=".encodeURIComponent(current_page);
        }

        // Filters
        var filters = [];
        var filterGroup = [];

        var filterInProgress = false;

        var filteredEver = false;

        // Setup our Filter UI actions
        setupFilters = function ()
        {

          var $filterbar_button = $$('.filter-bar__button');

          var $filter_clear = $$('[data-ref="filter-clear"]');

          var $filterbar_form = $$('[data-ref="filter-bar-form"]');
          var $filterbar_form_sidebar = $$('.filter-sidebar').find('[data-ref="filter-bar-form"]');
          var $filterbar_form_sortby = $$('.filter-bar__form-sortby');
          var $filterbar_form_topbar = $$('.filter-bar__filter');

            // Filters menu
            $filterbar_button.on('click', function(e) {
              e.preventDefault();
              var toggleElement = $$('.filter-bar__toggle');
              var toggleElementThis = $(this).next(toggleElement);
              var overlay = $('.collection');

              if($(this).hasClass('active')) {
                $(this).removeClass('active');
              } else {
                $filterbar_button.removeClass('active');
                $(this).addClass('active');
              }

              if(!toggleElementThis.hasClass('active')) {
                toggleElement.slideUp().removeClass('active');
                toggleElementThis.slideDown().addClass('active');
                overlay.addClass('active');
              } else if ($$('.collection-menu').hasClass('active') && toggleElementThis.hasClass('active')) {
                toggleElement.slideUp().removeClass('active');
              } else {
                toggleElement.slideUp().removeClass('active');
                overlay.removeClass('active');
              }
            });


            $filter_clear.on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                console.log("clear");
                
                var current_col = $collectionMain.data("current-col");
                window.location.href = current_col;
            });


          // Trigger forms on click
          $filterbar_form_sidebar.find('.collection-filter-item--desktop').on('click', function () {
            $filterbar_form_sidebar.find('button[type="submit"]').trigger('click');
          });
          $filterbar_form_sortby.find('.collection-filter-item--desktop').on('click', function () {
            $filterbar_form_sortby.find('button[type="submit"]').trigger('click');
          });

          $$("#mobile-filter-apply").on('click', function (e) {
            e.preventDefault();
            var $form = $(this).parent().parent(".filter-bar__form");
            var $items = $form.find(".filter-bar__form-lists .collection-filter-item.active-filter-item");

            var filters = genFilterFromItems($items);

            var url = buildFilterUrl(filters['list'], filters['tags']);

            window.location.href = url;
          });

          $filterbar_form_topbar.find('#desktop-filter-apply').on('click', function () {
           // $filterbar_form_topbar.find('.filter-bar__button').trigger('click');
            //$(".filter-bar__button.active").trigger('click');

            var $form = $(this).parent().parent(".filter-bar__form");
            var $items = $form.find(".filter-bar__form-lists .collection-filter-item.active-filter-item");

            var filters = genFilterFromItems($items);

            /*
            filters['list'] = '';
            filters['tags'] = [];


            $items.each(function( index ) {
              var type = $(this).data("type");
              if(type == "tag")
              {
                var tag = $(this).data("tag");

                if(tag)
                {
                  filters['tags'].push( tag );
                }


              }
              else if(type == "list")
              {
                var list = $(this).data("list");

                if(list)
                {
                  filters['list'] = list;
                }
              }

            });*/

            var url = buildFilterUrl(filters['list'], filters['tags']);

            window.location.href = url;

          });

          function genFilterFromItems($items)
          {

            var filters = [];
            filters['list'] = '';
            filters['tags'] = [];

            if($items && $items.length > 0)
            {

              $items.each(function( index ) {
                var type = $(this).data("type");
                if(type == "tag")
                {
                  var tag = $(this).data("tag");

                  if(tag)
                  {
                    var tag = tag.replace(/\./g, '-');
                    filters['tags'].push( tag );
                  }
                }
                else if(type == "list")
                {
                  var list = $(this).data("list");

                  if(list)
                  {
                    filters['list'] = list;
                  }
                }

              });

            }


            if(filters['list'] == ''){
              var $col_base = $('#colbase');
              if($col_base.length > 0){
                var collection_base = $col_base.data("collection-base");

                if(collection_base != ''){
                  filters['list'] = collection_base;
                }

              }
            }


            return filters;
          }


          function buildFilterUrl(list, tags)
          {
            var new_url = '';
            var base = '';

            if(list == '')
            {
              base = '/collections/all'
            }
            else {
              base = list;
            }


            var tag_string = '';

            if(Array.isArray(tags))
            {
              var arrayLength = tags.length;

              if(arrayLength >= 1){
                var clength = tags.length - 1;

                for (var i = 0; i < arrayLength; i++) {
                  tag_string = tag_string+tags[i];

                  if(i < clength){
                    tag_string = tag_string+"+";
                  }
                }

              }

            }

            new_url = base + "/"+tag_string;

            return new_url;

          }


            $$('.filter-bar__form.filter-bar__toggle a').on('click', function(e) {

              e.preventDefault();
              //e.stopPropagation();

              var $filter_parent = $(this).parent(".collection-filter-item");
              var $filter_group = $filter_parent.parent();

              var is_primary = false;
              var type = $filter_group.data("type");

              if(type == "primary"){
                is_primary = true;
              }

              if(!$filter_parent.hasClass("active-filter-item")){
                
                $filter_group.find(".collection-filter-item").removeClass("active-filter-item");
                $filter_parent.addClass("active-filter-item");
                console.log("add");
              }
              else {
                if(!is_primary){
                  $filter_parent.removeClass("active-filter-item");
                  console.log("remove");
                }
              }

            });


        };

        return {
          init: function () {
            setupFilters();

          }
        }
      }());



    $(document).ready(function() {
      console.log("Launching collection page");
      collectionPage.init();


      $$('.collection-mobile__sort').perfectScrollbar();
      $$('.collection-mobile__filter').perfectScrollbar();

      // disable filters buttons
      /*
      $('.filter-apply-loading').prop('disabled', true).html(function() {
        var original_button_height = $( this ).height();
        return '<span class="text" style="display:none">' + $( this ).text() + '</span><span class="lds-css ng-scope"><span style="height:' + original_button_height + 'px" class="lds-rolling"><span></span></span></span>';
      });
      $('.filter-bar__form-lists').prepend('<div class="filter-overlay"></div>');
    */

      // Filter sidebar fixed
      var sidebarTopSpacing = 0;
      if($(window).scrollTop() > 10) {
        sidebarTopSpacing = bars.barsHeight();
      } else {
        sidebarTopSpacing = bars.barsHeight() - $('.site-header__promo-banner').outerHeight();
      }
      $$('.filter-sidebar').sticky({
        topSpacing: sidebarTopSpacing,
        wrapperClassName: 'filter-sidebar-sticky-wrapper',
        bottomSpacing: $('.footer').outerHeight() + 100
      });


      // Filter list accordion
      $$('.collection-filter-list').accordion({ singleOpen: false  });

      // Collection menu
      $$('.filter-bar__select-button').on('click', function(e) {
        e.preventDefault();
        var toggleElement = $$('.collection-menu');
        var overlay = $$('.collection');

        $(this).toggleClass('active');

        if(!overlay.hasClass('active') && !toggleElement.hasClass('active')) {
          overlay.addClass('active');
          toggleElement.slideDown().addClass('active');
        } else if (overlay.hasClass('active') && !toggleElement.hasClass('active')) {
          overlay.addClass('active');
          toggleElement.slideDown().addClass('active');
        } else if (overlay.hasClass('active') && toggleElement.hasClass('active') && $$('.filter-bar__toggle').hasClass('active')) {
          toggleElement.slideUp().removeClass('active');
        } else if (overlay.hasClass('active') && toggleElement.hasClass('active') && !$$('.filter-bar__toggle').hasClass('active')) {
          overlay.removeClass('active');
          toggleElement.slideUp().removeClass('active');
        }

      });

      // Close filters on outer click
      $$(document).mouseup(function(e) {
        var menuContainer = $('.filter-bar__select');
        var sortContainer = $('.filter-bar__options');
        var overlay = $('.collection');

        if (overlay.hasClass('active') && !menuContainer.is(e.target) && menuContainer.has(e.target).length === 0 && !sortContainer.is(e.target) && sortContainer.has(e.target).length === 0) {
          menuContainer.find('.collection-menu').removeClass('active');
          sortContainer.find('.filter-bar__toggle').slideUp().removeClass('active');
          sortContainer.find('.filter-bar__button').removeClass('active');
          overlay.removeClass('active');
        }
      });

      // Sort by
      $$('#sortby li, #filter_sortby_featured, #filter_sortby_bestsellers, #filter_sortby_pricel, #filter_sortby_priceh, #filter_sortby_newest').on('click', function() {
        var sortValue = $(this).data("sort");

        if(sortValue)
        {
          window.location = '?sort_by=' + sortValue;
        }
      });

      // Mobile filter & sort modals
      $$('#collectionMobileButtonFilter').on('click', function(e) {
        e.preventDefault();
        $$('.site-header').css({'z-index': '0'});
        $$('.collection-mobile__filter').slideDown().addClass('active');
      });
      $$('#collectionMobileButtonSort').on('click', function(e) {
        e.preventDefault();
        $$('.site-header').css({'z-index': '0'});
        $$('.collection-mobile__sort').slideDown().addClass('active');
      });
      $$('.mobile-close-filter').on('click', function(e) {
        e.preventDefault();
        $$('.collection-mobile__filter').slideUp().removeClass('active');
        $$('.collection-mobile__sort').slideUp().removeClass('active');
        $$('.site-header').css({'z-index': '110'});
      });





    });

})();
// 
/*================ Modules ================*/
(function() {
  if (!window.theme.mlconf || !window.theme.mlconf.useGeoLookup) {
    console.log('ML mode disabled');
    return false;
  }
  var MLSM = '';
  var isLocalhost = window.location.hostname === 'localhost' ||
    window.location.hostname.indexOf('192.168.') !== -1;

  var currentStore = window.theme.mlconf.currentStore;
  var mlsmEnabled = window.theme.mlconf.enableMultilingualSitemode;
  var useRedirect = window.theme.mlconf.useRedirect;
  var showSelector = window.theme.mlconf.showSelector;
  var activeStore = window.theme.mlconf.activeStoreCountry;
  var storesCountry = window.theme.mlconf.activeStoreCountry;
  var countryStore = window.theme.mlconf.activeStoreCountry;
  var userCountry = '';
  var lookupAlreadyOnStoreFlag = false;
  var cookieRedirectName = 'store_redirect';
  var cookieSelectorName = 'store_selector';

  MultilingualSiteMode = (function() {

    /* Store Conf */
    var stores = {
      'US' : window.theme.mlconf.store_us,
      'EU' : window.theme.mlconf.store_eu,
      'ROW' : window.theme.mlconf.store_us
    };

    var redirects = {
      'US' : window.theme.mlconf.store_us_redirect,
      'EU' : window.theme.mlconf.store_eu_redirect,
      'ROW': window.theme.mlconf.store_us_redirect
    };

    /* Country to Store Configuration */
    var countries = {
      'US' : { 'Name':'USA', 'Store': redirects.US },
      'AT' : { 'Name':'Austria', 'Store': redirects.EU },
      'BE' : { 'Name':'Belgium', 'Store': redirects.EU },
      'BG' : { 'Name':'Bulgaria', 'Store': redirects.EU },
      'HR' : { 'Name':'Croatia', 'Store': redirects.EU },
      'CY' : { 'Name':'Republic of Cyprus', 'Store': redirects.EU },
      'CZ' : { 'Name':'Czech Republic', 'Store': redirects.EU },
      'DK' : { 'Name':'Denmark', 'Store': redirects.EU },
      'EE' : { 'Name':'Estonia', 'Store': redirects.EU },
      'FI' : { 'Name':'Finland', 'Store': redirects.EU },
      'FR' : { 'Name':'France', 'Store': redirects.EU },
      'DE' : { 'Name':'Germany', 'Store': redirects.EU },
      'GR' : { 'Name':'Greece', 'Store': redirects.EU },
      'HU' : { 'Name':'Hungary', 'Store': redirects.EU },
      'IE' : { 'Name':'Ireland', 'Store': redirects.EU },
      'IT' : { 'Name':'Italy', 'Store': redirects.EU },
      'LV' : { 'Name':'Latvia', 'Store': redirects.EU },
      'LT' : { 'Name':'Lithuania', 'Store': redirects.EU },
      'LU' : { 'Name':'Luxembourg', 'Store': redirects.EU },
      'MT' : { 'Name':'Malta', 'Store': redirects.EU },
      'NL' : { 'Name':'Netherlands', 'Store': redirects.EU },
      'PL' : { 'Name':'Poland', 'Store': redirects.EU },
      'PT' : { 'Name':'Portugal', 'Store': redirects.EU },
      'RO' : { 'Name':'Romania', 'Store': redirects.EU },
      'SK' : { 'Name':'Slovakia', 'Store': redirects.EU },
      'SI' : { 'Name':'Slovenia', 'Store': redirects.EU },
      'ES' : { 'Name':'Spain', 'Store': redirects.EU },
      'SE' : { 'Name':'Sweden', 'Store': redirects.EU },
      'GB' : { 'Name':'United Kingdom', 'Store': redirects.EU }
    };

    function MultilingualSiteMode() { }
    MultilingualSiteMode.prototype = $.extend({}, MultilingualSiteMode.prototype, {
      getLocation: function() {
        console.log('MLSM: performing lookup');
        var redirectLocation = this.getRedirectCookie();
        if (redirectLocation) {
          if (isLocalhost) {
            console.log('MLSM: on localhost, skipping redirect - '+redirectLocation);
            return;
          }
          
          if (redirectLocation !== true) {
            if(useRedirect)
            {
              console.log('MLSM: redirecting to '+redirectLocation);
              window.top.location.href = redirectLocation;
            }
            else {
              console.log('MLSM: Redirection disabled - would redirect to '+redirectLocation);
            }
          } else {
            console.log('MLSM: no action required');
            return;
          }
        } else {
          console.log('MLSM: geoip2 API lookup');
          geoip2.country(this.processResponse, this.processError);
        }
      },
      // Process GeoIP2 Lookup then show popup if needed
      processResponse: function(data) {

        // Set the default
        var location = redirects['ROW'];

        if (typeof(data.country.iso_code) !== 'undefined') {
          if (typeof(countries[data.country.iso_code]) !== 'undefined') {

            if (countries[data.country.iso_code]['Store'] !== activeStore) {
              location = countries[data.country.iso_code]['Store'];
            } else {
              console.log('MLSM: on the correct store', data.country.iso_code);
              lookupAlreadyOnStoreFlag = true;
              $( document ).trigger( "mlsm_process_response_finished", [ data ] );
              return false;
            }
          }
        }

        if (activeStore === location) {
          lookupAlreadyOnStoreFlag = true;
          console.log('MLSM: on the correct store already', activeStore);
          $( document ).trigger( "mlsm_process_response_finished", [ data ] );
          return false;
        }

        MLSMconfigFunction(activeStore, location);

        console.log('MLSM: suggesting location', location);
        $( document ).trigger( "mlsm_process_response_finished", [ data ] );
      },
      // Process GeoIP2 Lookup Error
      processError: function(data) {
        console.log("MLSM: fail - " + JSON.stringify(data, undefined, 4));
      },
      // Perform IP lookup and return data
      countryLookup: function(callback) {
        var that = this; // I know…
        geoip2.country(
          function(data) {
            that.setUsersCountry(data);
            if (callback) {
              callback();
            }
          },
          function(data) {
            that.processError(data);
            if (callback) {
              callback();
            }
          }
        );
      },
      setUsersCountry: function(data) {
        userCountry = data.country.names.en;

        if (typeof(countries[data.country.iso_code]) !== 'undefined') {
          countryStore = countries[data.country.iso_code]['Store'];
        }
      },
      // Return the stores country name
      getCountryStore: function() {
        return countryStore;
      },
      // Return the users country - should only be called after setUsersCountry
      getUsersCountry: function() {
        return userCountry;
      },
      // Return the stores URL
      getCountryUrl: function() {
        return stores[countryStore];
      },
      getlookupAlreadyOnStoreFlag: function() {
        return lookupAlreadyOnStoreFlag;
      },
      // Check if the redirect cookie exists
      getRedirectCookie: function() {
        if (Cookies.get(cookieRedirectName)) {
          var currentLocation =  window.location.host;
          var cookiedLocation = Cookies.get(cookieRedirectName);
          var cookieWithoutProtocol = cookiedLocation.replace("https://","").replace("http://", "").replace("\/", "");

          if (cookieWithoutProtocol == currentLocation) {
            return true;
          } else {
            return "https://" + cookieWithoutProtocol + window.location.pathname + window.location.search;
          }
        }
        return false;
      }
    });

    return MultilingualSiteMode;
  })();

  function storeSelectPopup(go_to_store) {
    Cookies.set('store_selector', true, { expires: 360, path: '/' });

    $(".store-select-box .store-select-col li").hide();
    $(".store-select-col[data-ref='active-store'] li a[data-region-code='" + activeStore + "']").parent().show();
    $(".store-select-col[data-ref='suggested-store'] li a[data-region-code='" + go_to_store + "']").parent().show();
    $('.store-select-overlay').show();
  }

  function storeSelectModal(go_to_store) {
    Cookies.set('store_selector', true, { expires: 360, path: '/' });

    $(".store-select-box .store-select-col li").hide();
    $(".store-select-col[data-ref='active-store'] li a[data-region-code='" + activeStore + "']").parent().show();
    $(".store-select-col[data-ref='suggested-store'] li a[data-region-code='" + go_to_store + "']").parent().show();
  }

  function getRedirectUrl(base) {
    return base + window.location.pathname + window.location.search;
  }

  function MLSM_redirect(url) {
    console.log('MLSM: redirecting to', url);

    if (url.indexOf('//' + window.location.host) === -1) {
      Cookies.set('', url, { expires: 360, path: '/' });

      var baseDomain = url;
      var fullDomain = getRedirectUrl(baseDomain);

      if (isLocalhost) {
        console.log('MLSM: on localhost, skipping redirect');
        return false;
      }

      window.top.location.href = fullDomain;
    } else {
      console.log('MLSM: already on domain, skipping redirect');
    }
  }

  function handleStoreSelection(e) {
    e.preventDefault();

    var baseDomain = $(this).attr("href");
    var fullDomain = getRedirectUrl(baseDomain);

    Cookies.set(cookieRedirectName, $(this).attr("href"), { expires: 360, path: '/' });

    if (window.location.href.search( baseDomain ) === -1) {
      window.top.location.href = fullDomain;
    } else {
      $('.store-select-overlay').fadeOut(500);
    }
  }

  function setAsActiveStore() {
    Cookies.set(cookieSelectorName, true, { expires: 360, path: '/' });
    Cookies.set(cookieRedirectName, window.location.host, { expires: 360, path: '/' });
  }

  function inIframe() {
      try {
          return window.self !== window.top;
      } catch (e) {
          return true;
      }
  }

  // Config function
  function MLSMconfigFunction(activeStore, location) {
      if (currentStore === 'amerii') {
          if (activeStore === 'EU') {
            if (location === 'EU') {
              console.log('MLSM: on the correct store already', activeStore);
            } else if (location === 'US') {
              console.log('MLSM: redirects to US');
              MLSM_redirect(window.theme.mlconf.store_us);
            } else {
              console.log('MLSM: redirects to US');
              MLSM_redirect(window.theme.mlconf.store_us);
            }
          }

          if (activeStore === 'US') {
            if (location === 'US') {
              console.log('MLSM: on the correct store already', activeStore);
            } else if (location === 'EU') {
              console.log('MLSM: US Popup');
              storeSelectPopup(location);
            } else {
              console.log('MLSM: on the correct store already', activeStore);
            }
          }        
      }
  }
  // Config modal selector function
  function ModalConfigFunction(activeStore) {
      if (currentStore === 'amerii') {
          if (activeStore === 'EU') {
            $(document).on('opening', '.store-selector-modal', function () {
              console.log('Modal is opening');
              storeSelectModal('US');
            });
          }

          if (activeStore === 'US') {
            $(document).on('opening', '.store-selector-modal', function () {
              console.log('Modal is opening');
              storeSelectModal('EU');
            });
          }        
      }
  }

  function init() {
    if (inIframe()) {
      console.log('MLSM: in iframe, disabling');
      return false;
    }

    if (!mlsmEnabled) {
      console.log('MLSM: disabled');
      return false;
    }

    if (!window.geoip2) {
      console.log('MLSM: not available (skipping country selector)');
      return false;
    }

    // ?select_store=1 means the user selected this store intentionally
    var isStorePreSelected = (window.location.search.search('select_store=1') !== -1);
    if (isStorePreSelected) {
      if (showSelector) {
        console.log('MLSM: pre-chosen, setting store as selection');
        setAsActiveStore();
      } else {
        console.log('MLSM: pre-chosen, setting store as selection');
        return setAsActiveStore();
      }
    }

    MLSM = new MultilingualSiteMode();

    $( document ).on( "mlsm_process_response_finished", function( event, arg1 ) {
        if(MLSM.getlookupAlreadyOnStoreFlag())
        {
          console.log("MSLM: On suggested store, storing");
          setAsActiveStore();
        }
    });

    if (showSelector) {
      ModalConfigFunction(activeStore);
      $('.store-select-box .store-select-col a').click(handleStoreSelection);
      MLSM.getLocation();

    } 
    else if (useRedirect) {

      MLSM.countryLookup(function() {
        console.log('MLSM: user is in: ' + MLSM.getUsersCountry() + ' Correct store: ' + MLSM.getCountryStore());
        MLSM_redirect(MLSM.getCountryUrl());
      });

    }    
  }

  $(document).ready(function() {
    init();
  });

}());
var bars = (function(){

	var bars = [];
	var barsHeights = [];
	var topPosition = 0;
	var barsTotalHeight = 0;

	
	function barOn(bar){
		if (!bar.hasClass('bar-on')) {
			bar.removeClass('bar-off').addClass('bar-on');
			_barsInit(bar);
		}
	}
	
	function barOff(bar){
		if (!bar.hasClass('bar-off')) {
			bar.removeClass('bar-on').addClass('bar-off');
			_barsInit(bar);
		}
	}

	function barFixedOn(bar){
		bar.removeClass('bar-fixed-off').addClass('bar-fixed-on');
	}

	function barFixedOff(bar){
		bar.removeClass('bar-fixed-on').addClass('bar-fixed-off');
	}

	function barsHeight(){
		return barsTotalHeight;
	}

	function _barsInit(bar, state) {
      bars = $('.bar-on:visible');
		barsHeights = [];

		bars.each(function(i){
			barsHeights.push($(this).outerHeight());
			_barZindex(i, $(this));
			_barTopPosition(i, $(this));
		});

		if (!bar.hasClass('js-product-bar-buy')) {
			_mainPaddingTop();
		}
	}

	function _barZindex(i, bar){
		bar.css({'zIndex': 10010 - i});
	}

	function _barTopPosition(i, bar){
		topPosition = 0;

		for (n=0; n<i; n++) {
			topPosition = topPosition + barsHeights[n];
		}
		
		bar.css({'top': topPosition + 'px'});
	}

	function _mainPaddingTop(){
		var paddingTop = 0;
		var $main = $('main');

		for (i=0; i<barsHeights.length; i++) {
			paddingTop = paddingTop + barsHeights[i];
		}

		$main.css({'paddingTop': paddingTop + 'px'});
		barsTotalHeight = paddingTop;
	}

	return {
		barOn: barOn,
		barOff: barOff,
		barFixedOn: barFixedOn,
		barFixedOff: barFixedOff,
		barsHeight: barsHeight
	};

})();

var barsSettings = (function(){
	
	var topbar = $('.site-header__banner-top');
	var navbar = $('.site-header__main');
	var promobar = $('.site-header__promo-banner');
	var productbuybar = $('.js-product-bar-buy');
	var filterbar = $('.filter-bar');
	var mobilenav = $('.site-nav__mobile');


	// Smooth top-padding transition
	topPaddingSmooth = function(){
		if($(window).scrollTop() < 200) {
			$('main').addClass('smooth-transition');
		} else {
			$('main').removeClass('smooth-transition');
		}
	};

	// Top bar
	topBarFunction = function(){
		if (topbar.length > 0) {
			var distanceToScroll = topbar.data('visible-distance');
			
			if($(window).scrollTop() > distanceToScroll && !topbar.hasClass('bar-is-fixed')) {
				bars.barOff(topbar);
			} else {
				bars.barOn(topbar);
			}
		}
	};

	// Promo bar
	promoBarFunction = function(){
		if (promobar.length > 0) {
			if($(window).scrollTop() > 10 && !promobar.hasClass('bar-is-fixed')) {
				bars.barOff(promobar);
			} else {
				bars.barOn(promobar);
			}
		}
	};

	// Product buy bar
	productBuyBarFunction = function(){
		if ($('body.template-product').length > 0) {
			var productBarBuyTrigger = $('#productBarBuyTrigger');
			if($(window).scrollTop() > productBarBuyTrigger.offset().top - bars.barsHeight()) {
				bars.barOn(productbuybar);
			} else {
				bars.barOff(productbuybar);
				$('.js-product-bar-buy-dropdown').hide();
				$('.js-product-bar-buy-overlay').removeClass('is-active');
			}
		}		
	};
	
	// Filter bar
	filterBarSticky = function() {
		if ($('body.template-collection').length > 0) {
			var filterBarTrigger = $('#filterBarTrigger');
			if ($(window).width() > 990) {
				if($(window).scrollTop() > filterBarTrigger.offset().top - bars.barsHeight()) {
					bars.barOn(filterbar);
					bars.barFixedOn(filterbar);
				} else {
					bars.barOff(filterbar);
					bars.barFixedOff(filterbar);
				}
			} else {
				bars.barOff(filterbar);
				bars.barFixedOff(filterbar);
			}
		}
	};
	
	// Filter bar
	filterSidebarSticky = function() {
		if ($('body.template-collection').length > 0) {
			var filterSidebarTrigger = $('#collection-main');
			if ($(window).width() > 990) {
				if($(window).scrollTop() > filterSidebarTrigger.offset().top - bars.barsHeight()) {
					$('.filter-sidebar').sticky({
						topSpacing: bars.barsHeight(),
						wrapperClassName: 'filter-sidebar-sticky-wrapper',
						bottomSpacing: $('.footer').outerHeight() + 100
					});
				} else {
					$('.filter-sidebar').unstick();
				}
			}
		}
	};
	
	// Faq sidebar
	faqSidebarSticky = function() {
		if ($('.faq__columns').length > 0) {
			if($(window).width() >= 768) {
				if($(window).scrollTop() > 0) {
					$('.faq__nav').sticky({
						topSpacing: bars.barsHeight(),
						bottomSpacing: $('.footer').outerHeight() + 100
					});
				} else {
					$('.faq__nav').unstick();
				}
			}
		}
	};

	// Mobile nav position
	mobileNavPosition = function() {
		mobilenav.css({'top': bars.barsHeight()});
	};
    
    swapLogos = function() {
      if($(window).scrollTop() > 48) {
        $('.site-header__logo, .site-header__main').addClass('scrolled');
      } else {
        $('.site-header__logo, .site-header__main').removeClass('scrolled');
      }
    };

	topPaddingSmooth();
	topBarFunction();
	promoBarFunction();

	$(window).on('load', function() {
		bars.barOn(topbar);
		bars.barOn(navbar);
		bars.barOn(promobar);
		
		productBuyBarFunction();
		filterBarSticky();
		filterSidebarSticky();
		faqSidebarSticky();
		mobileNavPosition();
        swapLogos();

		$(window).on('scroll resize', function() {
			topPaddingSmooth();
			topBarFunction();
			promoBarFunction();
			productBuyBarFunction();
			filterBarSticky();
			filterSidebarSticky();
			faqSidebarSticky();
			mobileNavPosition();
            swapLogos();
		});

	});






})();
// =require modules/bars.js

var productBarBuy = function() {
  $('.js-product-bar-buy-variant').click(function(event) {
    var value = $(this).data('value');
    $('.variant__link[data-value='+value+']').trigger('click');

    $('.js-product-bar-buy-dropdown').slideUp();
    $('.js-product-bar-buy-overlay').removeClass('is-active');
  });

  $('.js-product-bar-buy-dropdown-trigger').click(function(event) {
    $('.js-product-bar-buy-dropdown').slideToggle();
    $('.js-product-bar-buy-overlay').toggleClass('is-active');
  });
}

var productBarBuyMobile = function() {
  var _popup = $('.js-product-bar-buy-popup');

  $('#js-pp-add-to-cart-bar-mobile').on('click', function(e){
    e.preventDefault();
    
    var size = $('.js-product-bar-buy-select-size').val();
    if (size === 'false') {
      _popup.addClass('is-visible');
      return false;
    } else {
      _popup.removeClass('is-visible');

      var qty = $('#Quantity .product__qty').val();
      var variant = $('select.no-js[name="id"]').val();

      if ( $('[data-compare-price]').length > 0 ) {
        CartJS.addItem(variant, qty, {"_saleitem":""});
      } else {
        CartJS.addItem(variant, qty);
      }
    }

  });

  $('.js-product-bar-buy-select-size').change(function(event) {
    var value = $(this).val();
    if (value !== 'false') {
      $('.variant__link[data-value='+value+']').trigger('click');
      _popup.removeClass('is-visible');
    } else {
      $('.variant__list--0 .variant__link').removeClass('active');
    }
  });

  $('.variant__list--0 .variant__link').click(function(event) {
    _popup.removeClass('is-visible');
  });


  $('.js-product-bar-buy-scroll-to').click(function(event) {
    var optionsContainer = $(this).data('target');
    $('html, body').animate({
      scrollTop: $(optionsContainer).offset().top - bars.barsHeight() - 20
    }, 500, function() {
      $(optionsContainer).animate({marginLeft: '2px'}, 50)
        .animate({marginLeft: '-2px'}, 50)
        .animate({marginLeft: '2px'}, 50)
        .animate({marginLeft: '-2px'}, 50)
        .animate({marginLeft: '0'}, 50);
    });
  });
}
var productSizeGuideBar = function() {
  $('#sizeGuideBarATC').click(function() {
    $('.remodal').remodal().close();
    $('.product__form').trigger('submit');
  });
}

// Get all requests
function getRequests() {
    var s1 = location.search.substring(1, location.search.length).split('&'),
        r = {}, s2, i;

    for (i = 0; i < s1.length; i += 1) {
        s2 = s1[i].split('=');
        r[decodeURIComponent(s2[0]).toLowerCase()] = decodeURIComponent(s2[1]);
    }
    return r;
};

function updateQueryStringParameter(uri, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i");
  if( value === undefined ) {
    if (uri.match(re)) {
        return uri.replace(re, '$1$2');
    } else {
        return uri;
    }
  } else {
      if (uri.match(re)) {
          return uri.replace(re, '$1' + key + "=" + value + '$2');
      } else {
      var hash =  '';
      if( uri.indexOf('#') !== -1 ){
          hash = uri.replace(/.*#/, '#');
          uri = uri.replace(/#.*/, '');
      }
      var separator = uri.indexOf('?') !== -1 ? "&" : "?";    
      return uri + separator + key + "=" + value + hash;
    }
  }  
};

var HeaderFunction = (function() {
  return {
    init: function () {
      var $body = $$(document.body);
      var $document = $$(document);
      var $overlay = $$('#overlay');
      var $mobileNavAdvansed = $$('.site-nav__mobile--advanced');

      if ($mobileNavAdvansed.length > 0) {
        $document.on('click', '.site-nav__mobile-menu>button', function() {
          if($body.hasClass('mobile-open')) {
            $body.removeClass('mobile-open');
            $overlay.removeClass('overlay--active');
          } else {
            $body.addClass('mobile-open');
            $overlay.addClass('overlay--active');
          }
        });

        $document.on('click', '#overlay', function() {
          if($body.hasClass('mobile-open')) {
            $body.removeClass('mobile-open');
            $overlay.removeClass('overlay--active');
          }
        });
      } else {      
        $document.on('click', '.site-nav__mobile-menu>button', function() {
          if($body.hasClass('mobile-open')) {
            $body.removeClass('mobile-open');
          } else {
            //debugger;
            $('.site-nav__mobile').css({'top': $('.site-header__main').height()});
            $body.addClass('mobile-open');
          }
        });
      }

      $document.on('click', '.has-more .mobile-nav-icon', function(event) {
        //debugger;
        event.preventDefault();
        event.stopPropagation();
        var $this = $(this);
        if ($this.parent().hasClass('active')) {
          $this.parent().removeClass('active');
          $this.parents('a').next('ul').slideUp();
        } else {
          $this.parent().addClass('active');
          $this.parents('a').next('ul').slideDown();
        }
      });

      $document.on('click', '.site-header__banner-top__search .main-level-item-title, .site-nav__mobile-menu .site-search--trigger', function(event) {
        //console.log('a');
        var $this = $(this);
        if (!$body.hasClass('search-overlay-active')) {
          $body.addClass('search-overlay-active');
          event.stopPropagation();
        }
      });

      $document.on('click', function(event) {
        //console.log('body');
        if ($body.hasClass('search-overlay-active')) {
          var $form = $(event.target).closest('.search-overlay-form');
          // console.log($form);
          if ($form === null || $form.length === 0) {
            $body.removeClass('search-overlay-active');
            event.stopPropagation();
          }
        }
      });
      
      // // Header banner "close" button
      // $document.on('click', '.site-header__top-close', function() {
      //   $(this).closest('.site-header__top').remove();
      //   mobileNavPosition();

      //   if ($$('#collection-main').length > 0) {
      //     filterBarSticky();
      //   }
      //   if ($$('.privy-button-mobile').length > 0) {
      //     privyButtonFunction();
      //   }
      //   if ($$('.landing__section-hero').length > 0) {
      //     landingHeroSize();
      //   }
      // });

      if ($('.site-nav__banner__list').length > 0) {
        $('.site-nav__banner__list').slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          pauseOnFocus: false,
          autoplaySpeed: 4000,
          prevArrow: '<button type="button" class="slick-arrow" style="display: block;"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-left" viewBox="0 0 9.2 17.2"><path d="M9 16c.3.3.3.7 0 1s-.7.3-1 0L.2 9.1c-.3-.3-.3-.7 0-1L8 .2c.3-.3.7-.3 1 0 .3.3.3.7 0 1L1.9 8.6 9 16z"></path></svg><span class="visually-hidden">Previous</span></button>',
          nextArrow: '<button type="button" class="slick-arrow" style="display: block;"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-right" viewBox="0 0 9.2 17.2"><path d="M7.3 8.6L.2 1.2C-.1.9-.1.5.2.2c.3-.3.7-.3 1 0L9 8.1c.3.3.3.7 0 1L1.2 17c-.3.3-.7.3-1 0-.3-.3-.3-.7 0-1l7.1-7.4z"></path></svg><span class="visually-hidden">Next</span></button>'
        });
      }
    }
  }
}());

// Cart Popup
var cartPopupFunction = (function () {
  var body = $('body');
  var wrapper = $('#wrapper');
  var cartPopupContainer = $('#cartPopup');
  var overlay = $('#overlay');
  var cartPopupEmptyMessage = $('.cart-popup__empty');
  var cartButtonHeader = $('.cart-button-header');
  var cartPopupCloseButton = $('.cart-popup__close');

  console.log(CartJS);

  cartPopup = function(event, cart) {
    body.addClass('body--moved');
    wrapper.addClass('wrapper--moved');
    cartPopupContainer.addClass('cart-popup--active');
    overlay.addClass('overlay--active');

    $(document).bind( "mouseup touchend", function(e){
      if (!cartPopupContainer.is(e.target) && cartPopupContainer.has(e.target).length === 0 ) {
        cartPopupClose();
      }
    });

    if( CartJS.cart.items.length == 0) {
      cartPopupEmptyMessage.show();
    }

    cartItemSize();
    cartShippingMessage();

  };

  cartItemSize = function() {
    for( i = 0; i < CartJS.cart.items.length; i++ ) {
      if ( CartJS.cart.items[i].variant_title === null ) {
        $('[data-id='+ CartJS.cart.items[i].id +']').find('.cart-popup__item-size-val').html('Onesize');
      }
    }
  };

  cartShippingMessage = function() {
    var cartPopupShippingFree = $('.cart-popup__shipping-free');
    var cartPopupShippingAway = $('.cart-popup__shipping-away');
    var cartPopupShippingAmount = $('.cart-popup__shipping-amount');
    var cartPopupShippingLimit = cartPopupShippingAmount.data('money-value'); // free shipping total price limit
    var shippingCalc = cartPopupShippingLimit - CartJS.cart.total_price;
    
    if( shippingCalc <= 0 ){
      cartPopupShippingAway.hide();
      cartPopupShippingFree.show();
    } else {
      cartPopupShippingFree.hide();
      cartPopupShippingAway.show();
      cartPopupShippingAmount.html( '$' + (shippingCalc/100).toFixed(2) );
    }
  };

  cartPopupClose = function() {
    wrapper.removeClass('wrapper--moved');
    body.removeClass('body--moved');
    cartPopupContainer.removeClass('cart-popup--active');
    overlay.removeClass('overlay--active');
  };

  return {
    init: function () {

      $$(document).ready(function(){
        cartItemSize();
        cartShippingMessage();
      });

      $$(document).on('cart.requestComplete', function(event, cart){
        cartPopup();
      });

      cartButtonHeader.on('click', function(e){
        e.preventDefault();
        cartPopup();
      });

      cartPopupCloseButton.on('click', function(e){
        e.preventDefault();
        cartPopupClose();
      });

      $$(document).on('cart.requestComplete', function(event, cart){
        if( CartJS.cart.items.length === 0) {
          cartPopupEmptyMessage.show();
        } else {
          cartPopupEmptyMessage.hide();
        }
      });
    }
  }
}());

$(document).ready(function() {
//   $('.homepage-text-image__button, .faux-button').each(function(){
//     var $this = $(this);
//     $this.html($this.html().replace(/(\S+\s*\S+\s*\S+)$/, '<span class="inline-block">$1</span>'));
//   });
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  CartJS.init(window.theme.cartContents, {
    dataAPI: true,
    currency: window.theme.currency,
    moneyFormat: window.theme.moneyFormat,
    moneyWithCurrencyFormat: window.theme.moneyWithCurrencyFormat,
    weightUnit: 'kg',
    weightPrecision: 1
  });

  HeaderFunction.init();
  cartPopupFunction.init();

  var $cart_popup = $('.cart-popup');
  $cart_popup.perfectScrollbar();

  $$('.footer-accordion').accordion();

  var $template_product = $$('body.template-product'),
      $template_ring_size = $$('.container.container--sizing'),
      $sizing_table = $$('.sizing__table'),
      $size_guide_accordion = $$('.size-guide-accordion'),
      $root = $$('html, body');

  if ($template_ring_size.length > 0) {
    $sizing_table.perfectScrollbar();
  }
  
  if ($template_product.length > 0) {

    $sizing_table.perfectScrollbar();

    // Product guide accordion
    $size_guide_accordion.accordion();

    // Product bar Cart button
    $$('#js-pp-add-to-cart-bar').on('click', function(e){
      e.preventDefault();
      
      var qty = $('#Quantity .product__qty').val();
      var variant = $('select.no-js[name="id"]').val();

      if ( $('[data-compare-price]').length > 0 ) {
        CartJS.addItem(variant, qty, {"_saleitem":""});
      } else {
        CartJS.addItem(variant, qty);
      }
    });

    // Fake BIS (back in stock) button that triggers the main BIS button
    $$(document).on('click', '[data-ref="out-of-stock-app"]', function() {
      $$('#BIS_trigger')[0].click();
    });
    $$(document).on('click', '[data-ref="out-of-stock-klaviyo"]', function() {
      $$('.klaviyo-bis-trigger')[0].click();
    });

    // Smooth anchor link scroll
    var anchorClick = function(target, extraSpace){
      $$(document).on('click', target, function (event) {
        event.preventDefault();

        var scrollPos = $$(document).scrollTop();
        var offsetMinus = bars.barsHeight() + extraSpace;

        $root.animate({
          scrollTop: $($.attr(this, 'href')).offset().top - offsetMinus
        }, 500);
      });
    };
    anchorClick('.product__reviews', $('.js-product-bar-buy').outerHeight());
    anchorClick('.details-link', $('.js-product-bar-buy').outerHeight());
    anchorClick('.view-banner-info', $('.js-product-bar-buy').outerHeight());


    // Details tabs
    $$('.product-details__tab-contents').slick({
      dots: false,
      arrows: false,
      swipe: false,
      speed: 250,
      waitForAnimate: false,
    });

    // Product details accordion
    $$('.product-details__accordion').accordion();

    setTabUnderline = function($button) {
      var $tab = $button.find('.product-details__tabs');
      var $parent = $($button.parent());
      var width = $button.width();
      var height = $button.height();
      var $tabUnderline = $parent.find('.product-details__tab-underline');
      $tabUnderline.css('width', width+'px');
      var left = $button.offset().left - $parent.offset().left;
      var leftInPx = left + 'px';
      $tabUnderline.css('transform', 'translateX(' + leftInPx + ')');
    }

    $$(document).on('click', '.product-details__tab-buttons li', function(event) {
      event.preventDefault();
      var $this = $(this);
      var $tabs = $this.closest('.product-details__tabs');
      var $list = $this.closest('.product-details__tab-buttons').find('li');
      var index = $list.index($this);
      $list.removeClass('active');
      $this.addClass('active');
      $tabs.find('.product-details__tab-contents').slick('slickGoTo', index);
      setTabUnderline($this);
    });

    $$('.product-details__tab').each(function() {
      var $tab = $(this);
      var $tabContents = $tab.closest('.product-details__tab-contents');
      var height = $tab.outerHeight();
      var tabHeight = $tabContents.data('tabHeight');
      if (!tabHeight || height > tabHeight) {
        $tabContents.data('tabHeight', height);
      }
    });

    $$('.product-details__tab').each(function() {
      var $tab = $(this);
      var $tabContents = $tab.closest('.product-details__tab-contents');
      var tabHeight = $tabContents.data('tabHeight');
      $tab.css('min-height', tabHeight+'px');
    })

    var $button = $($('.product-details__tab-buttons li')[0]);
    $button.trigger('click');

    // Back in stock notification form (Shopify built)
    $('#notify-me').click(function() {
      $('#notify-me-wrapper').fadeIn();
      return false;
    });
    $('.variant__link').click(function() {
      $('#notify-me-wrapper').fadeOut();
      return false;
    });
  }

  if($$("#related-product-carousel").length > 0)
  {
    $$('#related-product-carousel').slick({
      lazyLoad: 'progressive',
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      appendArrows: "#related-slider-arrows",
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false
          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    }).on('beforeChange', function(){
      //myLazyLoad.update();
    });
  }

  if($$("#recommended-product-carousel").length > 0)
  {
    $$('#recommended-product-carousel').slick({
      lazyLoad: 'progressive',
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      appendArrows: "#recommended-slider-arrows",
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false
          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    }).on('beforeChange', function(){
      //myLazyLoad.update();
    });
  }
  
  $('.bg-pink h1, .bg-pink h2, .bg-pink p, .page-title, .faux-button, h1.home-block__title, p.home-block__subtitle, h2.homepage-charity__heading, p.homepage-charity__icon-text, p.homepage-text-image__text, h4.homepage-trending__title, .newsletter p').each(function(){
      var string = $(this).html();
      if (lastword(string).length <= 10) {
        string = string.replace(/ ([^ ]*)$/,'&nbsp;$1');
        $(this).html(string);
      }
  });  
  
  function lastword(words) {
    var n = words.split(" ");
    return n[n.length - 1];
  }  

});

// Fullwidth product carousel
if($$(".slick-slider--fullwidth").length > 0)
{
    $$('.slick-slider--fullwidth').slick({
      lazyLoad: 'progressive',
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
      arrows: true,
      appendArrows: ".fullwidth-slider-arrows",
      responsive: [
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    }).on('beforeChange', function(){
      //myLazyLoad.update();
    });
}

// Sidebar Template Page
$$(document).ready(function() {
  if ($$('.sidebar--fixed').length > 0) {

    // Fix sidebar at some point and remove fixed position at content bottom
    $$(window).scroll(function () {
      if($$(window).width() > 768) {

        fixedSidebarWidth();

        var fixSidebar = $$('.site-header').innerHeight();
        var contentHeight = $$('.page-content').innerHeight();
        var sidebarHeight = $$('.sidebar--fixed').height();
        var sidebarBottomPos = contentHeight - sidebarHeight;
        var trigger = $$(window).scrollTop() - fixSidebar + bars.barsHeight();

        if ($$(window).scrollTop() == 0) {
          $$('.sidebar--fixed').removeClass('fixed');
          $$('.sidebar--fixed').css({paddingTop: 0});
        } else {
          $$('.sidebar--fixed').addClass('fixed');
          $$('.sidebar--fixed').css({paddingTop: bars.barsHeight()});
        }

        if (trigger >= sidebarBottomPos) {
          $$('.sidebar--fixed').addClass('bottom');
        } else {
          $$('.sidebar--fixed').removeClass('bottom');
        }

      }
    });

    $$(window).resize(function () {
      fixedSidebarWidth();
    });

    // Assign correct width & position to the fixed sidebar
    fixedSidebarWidth = function () {
      var sidebarWidth = $$('.sidebar').width();
      var sidebarLeft = $$('.sidebar').offset().left;
      $$('.sidebar--fixed').css({width: sidebarWidth, left: sidebarLeft});
    }

  }
});

$$(document).ready(function() {

  var $colswatches = $('.collection__swatches');
  if($colswatches.length > 0){

    $('.collection__swatches.swatch-slider .variant__list').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        draggable: true,
        infinite: false,
        responsive: [
          {
            breakpoint: 9999,
            settings: {
              slidesToShow: 8,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 6,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 380,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          }
        ],
    });


    $('.collection__swatches .variant__link').on('click', function(e) {
      e.preventDefault();
      var matchVal = $(this).data("sysvalue");
      var pid = $(this).data("pid");
      var $parent_li = $('#gridprod-'+pid);
      var topline_text = $(this).data("topline-text");
      var $price = $parent_li.find('.collection-grid-item__price');
      var $tagsContainer = $parent_li.find('.collection-grid__item-tags');
      var $saleTag = $tagsContainer.find('.product-tag--sale');
      var saleTagType = $tagsContainer.data('sale-tag');

      var vid = $(this).data("vid");

      if(vid != '')
      {
        var $col_grid_item_link = $parent_li.find(".collection-grid-item__link");
        var href = $col_grid_item_link.attr("href");
        var new_href = updateQueryStringParameter(href,"variant",vid);

        $col_grid_item_link.attr("href", new_href);
      }



      //?variant=

      $parent_li.find(".collection__swatches .variant__link").removeClass("active");
      $(this).addClass("active");

      var $img_holder = $parent_li.find(".collection-grid-item__link .collection-grid-item__images");

      var $all_images = $img_holder.find('.swatch-gallery-images');

      var $active_front_img = $parent_li.find('.collection-grid-item__link > .collection-grid-item__images > img.collection-grid-item__image');
      var $active_hover_img = $parent_li.find('.collection-grid-item__link > .collection-grid-item__images > img.collection-grid-item__image--hover');

      var $new_front = $all_images.find('.collection-grid-item__image[data-color="'+matchVal+'"]');
      var $new_hover = $all_images.find('.collection-grid-item__image--hover[data-color="'+matchVal+'"]');


      $saleTag.remove();
      if($new_front.data('price')){
        $price.html(slate.Currency.formatMoney(parseInt($new_front.data('price')), theme.moneyFormat));
      }
      if($new_front.data('price-compare') > $new_front.data('price')){
        $parent_li.find('.collection-grid-item__price--sale').remove();
        $price.after('<span class="collection-grid-item__price collection-grid-item__price--sale">&nbsp;<s>'+ slate.Currency.formatMoney(parseInt($new_front.data('price-compare')), theme.moneyFormat) +'</s></span>');

        if(saleTagType == 'amount') {
          var comparePriceVal = $new_front.data('price-compare');
          var originalPriceVal = $new_front.data('price')
          var newSaleAmount = Math.floor((comparePriceVal - originalPriceVal) * 100 / comparePriceVal);
          $tagsContainer.append('<span class="product-tag product-tag--sale product-tag--red">- '+ newSaleAmount +'%</span>');
        } else {
          $tagsContainer.append('<span class="product-tag product-tag--sale product-tag--red">'+ saleTagType +'</span>');
        }
      } else {
        $parent_li.find('.collection-grid-item__price--sale').remove();
      }


      if($active_front_img.length > 0 && $new_front.length > 0){
        $active_front_img.remove();
        $img_holder.prepend($new_front.clone());
      }
      
      if($active_hover_img.length > 0 && $new_hover.length > 0){
        $active_hover_img.remove();
        $img_holder.prepend($new_hover.clone());
      }

      if(topline_text)
      {
        var $top_title = $parent_li.find('.collection-grid-item__link > .collection-grid-item__info > .collection-grid-item__vendor > .toptitle-cs');

        if($top_title.length > 0){
          $top_title.text(topline_text);
        }
      }

    });

  }

});

if ($$('#collection-main').length > 0 || $$('.trending').length > 0 || $$('.product-section--related').length > 0 || $$('.recommended-products').length > 0 || $$('.search-collection-grid').length > 0 ) {
  //var myLazyLoad = new LazyLoad();
}

// Instant search fix
$$(document).ready(function() {
  $$('.site-nav__mobile').scroll(function(){
    var headerHeight = bars.barsHeight();
    var searchInputHeight = $$('.mobile-main-level-item-searchform').outerHeight();
    var topDistance = $$('.mobile-main-level-item-searchform').offset().top;
    var scrollTop = $$(window).scrollTop();

    if(topDistance < scrollTop + headerHeight) {
      $$('#ui-id-1').css('top', headerHeight + 'px');
    } else {
      $$('#ui-id-1').css('top', headerHeight + searchInputHeight + 'px');
    }
  });
});

// Inaction carousel
$$(document).ready(function() {
  if($$("#inaction-product-carousel").length > 0) {
    $$('#inaction-product-carousel').slick({
      lazyLoad: 'progressive',
      slidesToShow: 6,
      slidesToScroll: 1,
      arrows: true,
      appendArrows: "#inaction-slider-arrows",
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        }
      ]
    }).on('beforeChange', function(){
      //myLazyLoad.update();
    }).on('breakpoint', function(){
      keepSlidesSquare();
    });

    var keepSlidesSquare = function(){
      setTimeout(function(){
        var stHeight = $('#inaction-product-carousel .slick-slide').width();
        $('#inaction-product-carousel .slick-slide').css('height',stHeight + 'px' );
      }, 100);
    }

    keepSlidesSquare();
    $(window).on('resize', function(){
      keepSlidesSquare();
    });
  }
});

// Reviews (product page)
function reviewsFunction(){
  if($$(".review").length > 0) {
    var $reviewsContainer = $('.review');
    var $reviewsList = $reviewsContainer.find('.review__list');
    var $reviewsNav = $reviewsContainer.find('.review__nav');
    var enableWritingReviews = $reviewsContainer.data('enable-reviews');
    var enableDevMode = $reviewsContainer.data('dev');
    var page = 1;
    var reviews_per_page = 5;
    var reviews_short_qty = 3;
    var appKey = $reviewsList.data('appkey');
    var productID = $reviewsList.data('product-id');
    var jsonURL = 'https://api.yotpo.com/v1/widget/' + appKey + '/products/' + productID + '/reviews.json?per_page=' + reviews_per_page + '&page=' + page + '&sort[]=date&sort[]=votes_up';

    $.getJSON(jsonURL, function(result) {
      var reviewsQty = result.response.reviews.length;

      buildingReviews = function(page, url, target) {

        var currentItemsQty = $('.reviews__item').length;

        // Get new reviews
        $.getJSON(url, function(result) {

          // Reviews items
          for(i = 0; i < result.response.reviews.length; i++) {

            // JSON content variables
            var review = result.response.reviews[i];
            var rev_content = review.content;
            var rev_created_at = review.created_at;
            var rev_custom_fields = review.custom_fields;
            var rev_id = review.id;
            var rev_product_id = review.product_id;
            var rev_score = review.score;
            var rev_sentiment = review.sentiment;
            var rev_source_review_id = review.source_review_id;
            var rev_title = review.title;
            var rev_verified_buyer = review.verified_buyer;
            var rev_votes_down = review.votes_down;
            var rev_votes_up = review.votes_up;
            var rev_user = review.user;
            var rev_user_display_name = review.user.display_name;
            var rev_user_is_social_connected = review.user.is_social_connected;
            var rev_user_social_image = review.user.social_image;
            var rev_user_user_id = review.user.user_id;
            var rev_user_user_type = review.user.user_type;

            // Verified user variable
            if (rev_verified_buyer) {
              var html_verified_buyer = $('<p>', {text: 'Verified Buyer'});
            } else {
              var html_verified_buyer = '';
            }

            // Review score variable
            switch(rev_score) {
            case 5:
              var html_score = '<i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i>';
              break;
            case 4:
              var html_score = '<i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i>';
              break;
            case 3:
              var html_score = '<i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i>';
              break;
            case 2:
              var html_score = '<i class="fa fa-star"></i><i class="fa fa-star"></i>';
              break;
            case 1:
              var html_score = '<i class="fa fa-star"></i>';
              break;
            default:
              var html_score = '';
            }

            // Review date variable
            var html_date = rev_created_at.split('T')[0].replace(/[-]/g, '/' );

            // Sharing links urls
            var share_href = window.location.href;
            var share_title = rev_title;
            var share_content = rev_content;

            var html_fb_url = 'https://www.facebook.com/sharer/sharer.php?u=' + share_href;
            var html_tw_url = '//twitter.com/home?status=' + share_content + share_href;
            var html_li_url = 'https://www.linkedin.com/shareArticle?mini=true&url=' +  + '&title=' + share_title + '&summary=' + share_content + '&source=';

            // Markup
            target
              .append($('<li>', {class: 'reviews__item clearfix'})
                  .append($('<div>', {class: 'review__stars'})
                    .append($('<div>', {class: 'review__stars-container'})
                      .append(html_score))
                    .append($('<div>', {class: 'review__date', html: html_date})))
                  .append($('<div>', {class: 'review__title', html: rev_title}))
                  .append($('<div>', {class: 'review__content'})
                    .append($('<div>', {class: 'review__content-text', html: rev_content}))
                    .append($('<div>', {class: 'review__user','data-user-id': rev_user_user_id, html: rev_user_display_name})
                      .append(html_verified_buyer)))
                  .append($('<div>', {class: 'review__sharing'})
                    .append($('<div>', {class: 'review__sharing-toggle', html: ' Share'})
                      .prepend($('<i>', {class: 'fa fa-share-square-o'})))
                    .append($('<div>', {class: 'review__sharing-links'})
                      .append($('<span>', {html: ' | '}))
                      .append($('<a>', {class: 'review__sharing-link', target: '_blank', href: html_fb_url})
                        .append($('<i>', {class: 'fa fa-facebook-official'})))
                      .append($('<a>', {class: 'review__sharing-link', target: '_blank', href: html_tw_url})
                        .append($('<i>', {class: 'fa fa-twitter'})))
                      .append($('<a>', {class: 'review__sharing-link', target: '_blank', href: html_li_url})
                        .append($('<i>', {class: 'fa fa-linkedin-square'})))))
                  .append($('<div>', {class: 'review__votes', 'data-review-id': rev_id, html: 'Was This Review Helpful?'})
                    .append($('<span>', {class: 'vote vote-up', 'data-vote-type': 'up', html: rev_votes_up})
                      .prepend($('<i>', {class: 'fa fa-thumbs-up'})))
                    .append($('<span>', {class: 'vote', 'data-vote-type': 'down', html: rev_votes_down})
                      .prepend($('<i>', {class: 'fa fa-thumbs-down'}))))
            );

            // Building short list of review
            if (page == 1 && i < reviews_short_qty && $('.review__item-short').length < reviews_short_qty) {
              $('.review__short')
                .append($('<li>', {class: 'review__item-short'})
                  .append($('<div>', {class: 'review-short__stars'})
                    .append($('<div>', {class: 'review-short__stars-container'})
                      .append(html_score)))
                  .append($('<div>', {class: 'review-short__title', html: rev_title}))
                  .append($('<div>', {class: 'review-short__content'})
                    .append($('<div>', {class: 'review-short__content-text', html: '"' + rev_content + '"'})))
                  .append($('<div>', {class: 'review-short__user','data-user-id': rev_user_user_id, html: rev_user_display_name + ', '})
                    .append($('<span>', {class: 'review-short__date', html: html_date})
                    .append(html_verified_buyer)))
              );
            }
          }

        }).done(function() {
          // Clear reviews list
          if (target.find('.reviews__item').length > reviews_per_page) {
            target.find('.reviews__item:lt(' + currentItemsQty + ')').remove();
          }
        });
      }

      buildingNavigation = function(url, target) {
        $.getJSON(url, function(result) {
          var reviews_page = result.response.pagination.page;
          var reviews_total = result.response.pagination.total;
          var reviews_pages = Math.ceil(reviews_total / reviews_per_page);

          if (reviews_pages > 1)

          // Adding navination links
          for (p = 0; p < reviews_pages; p++) {
            target
              .append($('<li>', {class: 'reviews-nav__item'})
                .append($('<span>', {class: 'reviews-nav__link', 'data-page': (p + 1), 'text': (p + 1)})));
          }

          // Navigation slider
          target.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            centerMode: true,
            centerPadding: 0,
            infinite: false,
            draggable: false,
            focusOnSelect: true,
            prevArrow: '<i class="fa fa-angle-left" aria-hidden="true"></i>',
            nextArrow: '<i class="fa fa-angle-right" aria-hidden="true"></i>'
          });

          // Total reiews number
          $('.product-section--reviews').find('.product-section__heading').prepend($('<span>', {html: reviews_total + ' '}));
          $('.review-toggle__qty').html('(' + reviews_total + ')');
        });
      }

      // Show Full reviews
      $('.review__button').on('click', function() {
        $('.review__full').toggleClass('active');
        $(this).toggleClass('active');

        if ( $(this).hasClass('active') ){
          $('.review-toggle__msg').html('Hide');
        } else {
          $('.review-toggle__msg').html('Read');
        }
      });

      // Building reviews pages on page number click
      $reviewsNav.on('afterChange', function(){
        var page = $(this).find('.slick-current .reviews-nav__link').data('page');
        var jsonURL = 'https://api.yotpo.com/v1/widget/' + appKey + '/products/' + productID + '/reviews.json?per_page=' + reviews_per_page + '&page=' + page + '&sort[]=date&sort[]=votes_up';

        buildingReviews(page, jsonURL, $reviewsList);

        $('html, body').animate({
          scrollTop: $('.review__button').offset().top - bars.barsHeight() - 40
        }, 500);
      });

      // Reviews sharing buttons
      $(document).on('click', '.review__sharing-toggle', function(){
        $(this).next('.review__sharing-links').toggleClass('active');
      });
      $(document).on('click', '.review__sharing-link', function(e){
        e.preventDefault();
        window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
        return false;
      });

      // Reviews vote
      $(document).on('click', '.vote', function(){
        var voteType = $(this).data('vote-type');
        var reviewId = $(this).closest('.review__votes').data('review-id');
        var that = this;
        var thisCallback = function(){ $(that).addClass('reviewed')};

        if (voteType == 'up') {
          $.getJSON('https://api.yotpo.com/reviews/' + reviewId + '/vote/up', thisCallback());
        } else {
          $.getJSON('https://api.yotpo.com/reviews/' + reviewId + '/vote/down', thisCallback());
        }
      });

      // Average product rating
      $.getJSON('https://api.yotpo.com/products/' + appKey + '/' + productID + '/bottomline', function(result) {
        var average_score = result.response.bottomline.average_score;
        var total_reviews = result.response.bottomline.total_reviews;

        if (average_score == 5) {
          var html_average_score = '<i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i>';
        } else if (average_score < 5 && average_score > 4) {
          var html_average_score = '<i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star-half"></i>';
        } else if (average_score == 4) {
          var html_average_score = '<i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i>';
        } else if (average_score < 4 && average_score > 3) {
          var html_average_score = '<i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star-half"></i>';
        } else if (average_score == 3) {
          var html_average_score = '<i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i>';
        } else if (average_score < 3 && average_score > 2) {
          var html_average_score = '<i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star-half"></i>';
        } else if (average_score == 2) {
          var html_average_score = '<i class="fa fa-star"></i><i class="fa fa-star"></i>';
        } else if (average_score < 2 && average_score > 1) {
          var html_average_score = '<i class="fa fa-star"></i><i class="fa fa-star-half"></i>';
        } else if (average_score == 1) {
          var html_average_score = '<i class="fa fa-star"></i>';
        } else if (average_score < 1 && average_score > 0) {
          var html_average_score = '<i class="fa fa-star-half"></i>';
        } else if (average_score == 0) {
          var html_average_score = '';
        }
        
        if(total_reviews > 0) {
          $('.product__stars .reviews-stars').append(html_average_score);
          $('.product__stars .reviews-text').html(total_reviews + ' Reviews');        
        }

      });

      // Building site reviews first page
      buildingReviews(page, jsonURL, $reviewsList);

      // Building site reviews nav
      buildingNavigation(jsonURL, $reviewsNav);

      // Show reviews section
      if (reviewsQty > 0) {
        $('.product-section--reviews').show();
      }
    }).error(function(jqXHR, textStatus, errorThrown) {
      $reviewsList
        .append($('<li>', {class: 'review__item'})
          .append($('<span>', {class: 'review__error', text: 'error: ' + errorThrown}))
      );
    });

    if (enableWritingReviews) {
      // New review
      newReview = function(){

        // Show & hide(reset) the review form
        $('.review__button-write').click(function() {
          if (!$(this).hasClass('active')) {
            $(this).addClass('active').html('Hide & Clear');
            $('.new-review input[type=submit]').attr('disabled', 'disabled').addClass('button--disabled');
            $('.review__write').slideDown();        
          } else {
            $(this).removeClass('active').html('Write a Review');
            $('.new-review input[type=submit]').attr('disabled', '').removeClass('button--disabled');
            $('.review__write').slideUp();
            $('.new-review').trigger('reset');
            $('.new-review__label').removeClass('checked');
            $('.review__success').slideUp();
            $('.review__error').slideUp();
          }
        });

        // Review score stars
        $('.new-review__label').mouseover(function() {
          $('.new-review__score').addClass('hovered');
          $(this).addClass('hovered').prevAll().addClass('hovered');
        });
        $('.new-review__label').mouseleave(function() {
          $('.new-review__score').removeClass('hovered');
          $('.new-review__score label').removeClass('hovered');
        });
        $('.new-review__radio[name=review_score]').change(function() {
          $('.new-review__score label').removeClass('checked');
          $(this).next('label').addClass('checked').prevAll().addClass('checked');
          validate();
        });

        // Form validating
        var validate = function () {
          var input = $('.form-input');
          var scoreInput = $('.new-review__radio[name=review_score]:checked');
          var isValid = false;

          if (scoreInput.val()) {
            $.each(input, function (k, v) {
              if (v.type != 'submit') {
                isValid = (k == 0) ?
                v.value ? true : false : isValid && v.value ? true : false;
              }
              if (isValid) {
                $('.new-review input[type=submit]').prop('disabled', false).removeClass('button--disabled');
              } else {
                $('.new-review input[type=submit]').prop('disabled', true).addClass('button--disabled');
              }
            });
          } else {
            $('.new-review input[type=submit]').prop('disabled', true).addClass('button--disabled');
          }
        };

        validate();
        $('.new-review .form-input').on('keyup', validate);

        // Form submit
        $('.new-review').submit(function(e) {
          e.preventDefault();

          var data_review_domain = $(this).data('review-domain');
          var data_review_sku = $(this).data('review-sku');
          var data_review_product_title = $(this).data('review-product-title');
          var data_review_product_url = $(this).data('review-product-url');

          // Clearing error messages
          $('.review__write .errors ul').empty();

          // Getting the form data
          var data = $(this).serializeArray();
          var obj = {};

          $.each(data, function(i, field){
            obj[field.name] = field.value;
          });

          var new_review_appkey = appKey;
          var new_review_domain = data_review_domain;
          var new_review_sku = data_review_sku;
          var new_review_product_title = data_review_product_title;
          var new_review_product_url = new_review_domain + data_review_product_url;
          var new_review_name = obj.review_name;
          var new_review_email = decodeURIComponent(obj.review_email);
          var new_review_content = obj.review_content;
          var new_review_title = obj.review_title;
          var new_review_score = obj.review_score;

          if(enableDevMode) {
            // Temp vars to use a correct url on dev website
            var new_review_domain = "https://moonmagic.com/";
            var new_review_product_url = new_review_domain + data_review_product_url;
          }

          $.ajax({
            type: "POST",
            url: "https://api.yotpo.com/v1/widget/reviews",
            data: {
              "appkey": new_review_appkey,
              "domain": new_review_domain,
              "sku": new_review_sku,
              "product_title": new_review_product_title,
              "product_url": new_review_product_url,
              "display_name": new_review_name,
              "email": new_review_email,
              "review_content": new_review_content,
              "review_title": new_review_title,
              "review_score": new_review_score
            },
            statusCode: {
              200: function(msg) {
                if (msg.message == "ok")
                $('.review__write').slideUp();
                $('.review__button-write').slideUp();
                $('.review__success').slideDown();
              },
              500: function(msg) {
                var errorMsg = msg.responseJSON.status.message;
                var errorOutput = '';

                switch(errorMsg) {
                case 'Missing display_name':
                  var errorOutput = 'Please fill in your name';
                  break;
                case 'Missing email':
                  var errorOutput = 'Email is invalid';
                  break;
                case 'Missing review_content':
                  var errorOutput = 'Please fill in review text';
                  break;
                case 'Missing review_title':
                  var errorOutput = 'Please fill in review title';
                  break;
                case 'Missing review_score':
                  var errorOutput = 'Please fill in review score';
                  break;
                default:
                  var errorOutput = 'Form post failed.  Please try again';
                }

                $('.review__write .errors ul').append($('<li>', {html: errorOutput}));
              }
            }
          })
          .fail(function() {
            $('.review__write').slideUp();
            $('.review__error').slideDown();
          });

          // Scroll the form
          $('html, body').animate({
            scrollTop: $('.review__button-write').offset().top - bars.barsHeight() - 40
          }, 500);
        });
        
      };

      newReview();
    }
  }
}
$$(document).ready(function() {
  reviewsFunction();
});

// Reviews (Reviews page)
function reviewsPageFunction(){
  if($$(".container--reviews").length > 0) {
    var $reviewsContainer = $('.container--reviews');
    var enableWritingReviews = $reviewsContainer.data('enable-reviews');
    var enableDevMode = $reviewsContainer.data('dev');

    // Reviews tabs
    $('.reviews-tabs__link').click(function(){
      var tab_id = $(this).attr('data-tab');

      $('.reviews-tabs__link').removeClass('current');
      $('.reviews-tabs__content').removeClass('current');

      $(this).addClass('current');
      $("#"+tab_id).addClass('current');

      if (enableWritingReviews) {
        // Hiding the "write a review" tab for product reviews (showing for site reviews)
        if ($(this).data('tab') == 'tab-2') {
          $('.reviews-tabs__link--write').addClass('active');
        } else {
          $('.reviews-tabs__link--write').removeClass('active');
        }

        // Reset the review form if other tab selected & scroll window if "write a review" tab is selected
        if ($(this).data('tab') != 'tab-3') {
          $('.new-review').trigger('reset');
          $('.new-review__label').removeClass('checked');
          $('.review__success').slideUp();
          $('.review__error').slideUp();
        } else {
          $('.review__write').slideDown();
          $('html, body').animate({
            scrollTop: $('.reviews-tabs').offset().top - bars.barsHeight() - 10
          }, 500);
        }
      }

      // Refreshing the navigation slider (due to possible render failures)
      $('.current .reviews__nav').slick('refresh');
    })


    // Reviews
    var appKey = $reviewsContainer.data('appkey');
    var page = 1;
    var reviews_per_page = 10;
    var jsonSiteURL = 'https://api.yotpo.com/v1/widget/' + appKey + '/products/yotpo_site_reviews/reviews.json?per_page=' + reviews_per_page + '&page=' + page + '&sort[]=date&sort[]=votes_up';
    var jsonAllURL = 'https://api.yotpo.com/v1/widget/' + appKey + '/reviews.json?per_page=' + reviews_per_page + '&page=' + page + '&sort[]=date&sort[]=votes_up';
    var reviews_site = $('.reviews-site');
    var reviews_all = $('.reviews-all');
    var reviews_site_tab = $('.reviews-tabs__link[data-tab="tab-2"]');
    var reviews_all_tab = $('.reviews-tabs__link[data-tab="tab-1"]');
    var reviews_site_list = reviews_site.find('.reviews__list');
    var reviews_all_list = reviews_all.find('.reviews__list');
    var reviews_site_nav = reviews_site.find('.reviews__nav');
    var reviews_all_nav = reviews_all.find('.reviews__nav');

    $.getJSON(jsonSiteURL, function(result) {

      buildingReviews = function(page, url, target) {

        var currentItemsQty = target.find('.reviews__item').length;

        // Get new reviews
        $.getJSON(url, function(result) {

          // Reviews items
          for(i = 0; i < result.response.reviews.length; i++) {

            // JSON content variables
            var review = result.response.reviews[i];
            var rev_content = review.content;
            var rev_created_at = review.created_at;
            var rev_custom_fields = review.custom_fields;
            var rev_id = review.id;
            var rev_product_id = review.product_id;
            var rev_score = review.score;
            var rev_sentiment = review.sentiment;
            var rev_source_review_id = review.source_review_id;
            var rev_title = review.title;
            var rev_verified_buyer = review.verified_buyer;
            var rev_votes_down = review.votes_down;
            var rev_votes_up = review.votes_up;
            var rev_user = review.user;
            var rev_user_display_name = review.user.display_name;
            var rev_user_is_social_connected = review.user.is_social_connected;
            var rev_user_social_image = review.user.social_image;
            var rev_user_user_id = review.user.user_id;
            var rev_user_user_type = review.user.user_type;

            var product = result.response.products[i];
            var prod_name = '';
            var prod_url = '';

            for(p = 0; p < result.response.products.length; p++) {
              if (result.response.products[p].id === rev_product_id) {
                var prod_name = result.response.products[p].name;
                var prod_url = result.response.products[p].product_link;
              }
            }

            // Verified user variable
            if (rev_verified_buyer) {
              var html_verified_buyer = $('<p>', {text: 'Verified Buyer'});
            } else {
              var html_verified_buyer = '';
            }

            // Review score variable
            switch(rev_score) {
            case 5:
              var html_score = '<i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i>';
              break;
            case 4:
              var html_score = '<i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i>';
              break;
            case 3:
              var html_score = '<i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i>';
              break;
            case 2:
              var html_score = '<i class="fa fa-star"></i><i class="fa fa-star"></i>';
              break;
            case 1:
              var html_score = '<i class="fa fa-star"></i>';
              break;
            default:
              var html_score = '';
            }

            // Review date variable
            var html_date = rev_created_at.split('T')[0].replace(/[-]/g, '/' );

            // Sharing links urls
            var share_href = window.location.href;
            var share_title = rev_title;
            var share_content = rev_content;

            var html_fb_url = 'https://www.facebook.com/sharer/sharer.php?u=' + share_href;
            var html_tw_url = '//twitter.com/home?status=' + share_content + share_href;
            var html_li_url = 'https://www.linkedin.com/shareArticle?mini=true&url=' +  + '&title=' + share_title + '&summary=' + share_content + '&source=';

            // Markup
            target
              .append($('<li>', {class: 'reviews__item clearfix'})
                  .append($('<div>', {class: 'review__stars'})
                    .append($('<div>', {class: 'review__stars-container'})
                      .append(html_score))
                    .append($('<div>', {class: 'review__date', html: html_date})))
                  .append($('<div>', {class: 'review__title', html: rev_title}))
                  .append($('<div>', {class: 'review__content'})
                    .append($('<div>', {class: 'review__content-text', html: rev_content}))
                    .append($('<div>', {class: 'review__user','data-user-id': rev_user_user_id, html: rev_user_display_name})
                      .append(html_verified_buyer)))
                  .append($('<a>', {class: 'review__link', href: prod_url, target: '_blank', html: prod_name}))
                  .append($('<div>', {class: 'review__sharing'})
                    .append($('<div>', {class: 'review__sharing-toggle', html: ' Share'})
                      .prepend($('<i>', {class: 'fa fa-share-square-o'})))
                    .append($('<div>', {class: 'review__sharing-links'})
                      .append($('<span>', {html: ' | '}))
                      .append($('<a>', {class: 'review__sharing-link', target: '_blank', href: html_fb_url})
                        .append($('<i>', {class: 'fa fa-facebook-official'})))
                      .append($('<a>', {class: 'review__sharing-link', target: '_blank', href: html_tw_url})
                        .append($('<i>', {class: 'fa fa-twitter'})))
                      .append($('<a>', {class: 'review__sharing-link', target: '_blank', href: html_li_url})
                        .append($('<i>', {class: 'fa fa-linkedin-square'})))))
                  .append($('<div>', {class: 'review__votes', 'data-review-id': rev_id, html: 'Was This Review Helpful?'})
                    .append($('<span>', {class: 'vote vote-up', 'data-vote-type': 'up', html: rev_votes_up})
                      .prepend($('<i>', {class: 'fa fa-thumbs-up'})))
                    .append($('<span>', {class: 'vote', 'data-vote-type': 'down', html: rev_votes_down})
                      .prepend($('<i>', {class: 'fa fa-thumbs-down'}))))
            );
          }

        }).done(function() {
          // Clear reviews list
          if (target.find('.reviews__item').length > reviews_per_page) {
            target.find('.reviews__item:lt(' + currentItemsQty + ')').remove();
          }
        });
      }

      buildingNavigation = function(url, target) {
        $.getJSON(url, function(result) {
          var reviews_page = result.response.pagination.page;
          var reviews_total = result.response.pagination.total;
          var reviews_pages = Math.ceil(reviews_total / reviews_per_page);

          // Adding navination links
          for (p = 0; p < reviews_pages; p++) {
            target
              .append($('<li>', {class: 'reviews-nav__item'})
                .append($('<span>', {class: 'reviews-nav__link', 'data-page': (p + 1), 'text': (p + 1)})));
          }

          // Navigation slider
          target.slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            centerMode: true,
            centerPadding: 0,
            infinite: false,
            draggable: false,
            focusOnSelect: true,
            prevArrow: '<i class="fa fa-angle-left" aria-hidden="true"></i>',
            nextArrow: '<i class="fa fa-angle-right" aria-hidden="true"></i>'
          });

          // Showing total number of reviews
          if ( target == reviews_site_nav ) {
            reviews_site_tab.append($('<span>', {'html': ' (' + reviews_total + ')'}));
          } else {
            reviews_all_tab.append($('<span>', {'html': ' (' + reviews_total + ')'}));
          }
        });
      }

      // Building reviews pages on page number click
      $('.reviews__nav').on('afterChange', function(){
        var page = $(this).find('.slick-current .reviews-nav__link').data('page');

        if ( $(this).parent('.reviews-site').length > 0 ) {
          var jsonSiteURL = 'https://api.yotpo.com/v1/widget/' + appKey + '/products/yotpo_site_reviews/reviews.json?per_page=' + reviews_per_page + '&page=' + page + '&sort[]=date&sort[]=votes_up';
          buildingReviews(page, jsonSiteURL, reviews_site_list);
        } else {
          var jsonAllURL = 'https://api.yotpo.com/v1/widget/' + appKey + '/reviews.json?per_page=' + reviews_per_page + '&page=' + page + '&sort[]=date&sort[]=votes_up';
          buildingReviews(page, jsonAllURL, reviews_all_list);
        }

        $('html, body').animate({
          scrollTop: $('.reviews-tabs').offset().top - bars.barsHeight() - 10
        }, 500);
      });

      // Reviews sharing buttons
      $(document).on('click', '.review__sharing-toggle', function(){
        $(this).next('.review__sharing-links').toggleClass('active');
      });
      $(document).on('click', '.review__sharing-link', function(e){
        e.preventDefault();
        window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
        return false;
      });

      // Reviews vote
      $(document).on('click', '.vote', function(){
        var voteType = $(this).data('vote-type');
        var reviewId = $(this).closest('.review__votes').data('review-id');
        var that = this;
        var thisCallback = function(){ $(that).addClass('reviewed')};

        if (voteType == 'up') {
          $.getJSON('https://api.yotpo.com/reviews/' + reviewId + '/vote/up', thisCallback());
        } else {
          $.getJSON('https://api.yotpo.com/reviews/' + reviewId + '/vote/down', thisCallback());
        }
      });



      // Building site reviews first page
      buildingReviews(page, jsonSiteURL, reviews_site_list);

      // Building all reviews first page
      buildingReviews(page, jsonAllURL, reviews_all_list);

      // Building site reviews nav
      buildingNavigation(jsonSiteURL, reviews_site_nav);

      // Building all reviews nav
      buildingNavigation(jsonAllURL, reviews_all_nav);

    }).error(function(jqXHR, textStatus, errorThrown) {
      $('.reviews__list')
        .append($('<li>', {class: 'review__item'})
          .append($('<span>', {class: 'review__error', text: 'error: ' + errorThrown}))
      );
    });

    if (enableWritingReviews) {
      // New review
      newReview = function(){

        // Review score stars
        $('.new-review__label').mouseover(function() {
          $('.new-review__score').addClass('hovered');
          $(this).addClass('hovered').prevAll().addClass('hovered');
        });
        $('.new-review__label').mouseleave(function() {
          $('.new-review__score').removeClass('hovered');
          $('.new-review__score label').removeClass('hovered');
        });
        $('.new-review__radio[name=review_score]').change(function() {
          $('.new-review__score label').removeClass('checked');
          $(this).next('label').addClass('checked').prevAll().addClass('checked');
          validate();
        });

        // Form validating
        var validate = function () {
          var input = $('.form-input');
          var scoreInput = $('.new-review__radio[name=review_score]:checked');
          var isValid = false;

          if (scoreInput.val()) {
            $.each(input, function (k, v) {
              if (v.type != 'submit') {
                isValid = (k == 0) ?
                v.value ? true : false : isValid && v.value ? true : false;
              }
              if (isValid) {
                $('.new-review input[type=submit]').prop('disabled', false).removeClass('button--disabled');
              } else {
                $('.new-review input[type=submit]').prop('disabled', true).addClass('button--disabled');
              }
            });
          } else {
            $('.new-review input[type=submit]').prop('disabled', true).addClass('button--disabled');
          }
        };

        validate();
        $('.new-review .form-input').on('keyup', validate);

        // Form submit
        $('.new-review').submit(function(e) {
          e.preventDefault();

          var data_review_domain = $(this).data('review-domain');
          var data_review_product_title = $(this).data('review-product-title');
          var data_review_product_url = $(this).data('review-product-url');

          // Clearing error messages
          $('.review__write .errors ul').empty();

          // Getting the form data
          var data = $(this).serializeArray();
          var obj = {};

          $.each(data, function(i, field){
            obj[field.name] = field.value;
          });

          var new_review_appkey = appKey;
          var new_review_domain = data_review_domain;
          var new_review_sku = "yotpo_site_reviews";
          var new_review_product_title = data_review_product_title;
          var new_review_product_url = data_review_product_url;
          var new_review_name = obj.review_name;
          var new_review_email = decodeURIComponent(obj.review_email);
          var new_review_content = obj.review_content;
          var new_review_title = obj.review_title;
          var new_review_score = obj.review_score;

          if (enableDevMode) {
            // Temp vars to use a correct url on dev website
            var new_review_domain = "https://moonmagic.com/";
            var new_review_product_url = "https://moonmagic.com/";
          }

          $.ajax({
            type: "POST",
            url: "https://api.yotpo.com/v1/widget/reviews",
            data: {
              "appkey": new_review_appkey,
              "domain": new_review_domain,
              "sku": new_review_sku,
              "product_title": new_review_product_title,
              "product_url": new_review_product_url,
              "display_name": new_review_name,
              "email": new_review_email,
              "review_content": new_review_content,
              "review_title": new_review_title,
              "review_score": new_review_score
            },
            statusCode: {
              200: function(msg) {
                if (msg.message == "ok")
                $('.review__write').slideUp();
                $('.review__success').slideDown();
              },
              500: function(msg) {
                var errorMsg = msg.responseJSON.status.message;
                var errorOutput = '';

                switch(errorMsg) {
                case 'Missing display_name':
                  var errorOutput = 'Please fill in your name';
                  break;
                case 'Missing email':
                  var errorOutput = 'Email is invalid';
                  break;
                case 'Missing review_content':
                  var errorOutput = 'Please fill in review text';
                  break;
                case 'Missing review_title':
                  var errorOutput = 'Please fill in review title';
                  break;
                case 'Missing review_score':
                  var errorOutput = 'Please fill in review score';
                  break;
                default:
                  var errorOutput = 'Form post failed.  Please try again';
                }

                $('.review__write .errors ul').append($('<li>', {html: errorOutput}));
              }
            }
          })
          .fail(function() {
            $('.review__write').slideUp();
            $('.review__error').slideDown();
          });
        });
        
      };

      newReview();
    }
  }
}
$$(document).ready(function() {
  reviewsPageFunction();
});


function blogsInfiniteScroll() {
  if($$(".template-blog").length > 0) {
    var pageNumber = 1;
    var postsWrapper = $('#MainContent');
    var pagination = $('.pagination')
    pagination.hide();
    $(window).on('scroll', function() {
        if ($(this).scrollTop() >= postsWrapper.offset().top + postsWrapper.outerHeight() - window.innerHeight ) {
          
          nextButton = $('.pagination .next a');    
          nextButtonURL = nextButton.attr("href");
          
          if(nextButton.length > 0 && nextButton.css('display') != 'none') {
            $.ajax({
                type: 'GET',
                url: nextButtonURL,
                beforeSend: function() {

                    nextButton.hide();
                    
                    //show loading icon
                    $('.lds-css').css('display', 'flex');

                },
                success: function(data) {
                    //hide loading icon
                    $('.lds-css').hide();

                    var filteredBlogItem = $(data).find(".blog__item");
                    var filteredPagination = $(data).find(".pagination").contents();
                    $(".blog__list").append(filteredBlogItem);
                    pagination.html(filteredPagination);

                    pageNumber++;
                    nextButton.attr("href", nextButtonURL.replace(/\d/g, pageNumber.toString()) );
                    console.log(data);              
                },
                dataType: "html"
            });
          } 
        }
    });
  }
}
$$(document).ready(function() {
  blogsInfiniteScroll();
});

// Hide Yotpo "Write a review" on a product page if there are no review
function hideYotpoWriteReview(){
  function elementLoaded(){
    var element = $('.product__reviews.product__stars');
    if(element.length > 0) {
      clearInterval(window.elementCheckInterval);
      if ( element.text().indexOf('Write') >= 0 ) {
        $('.product__reviews.product__stars .yotpo.bottomLine').hide();
      }
    }
  }
  window.elementCheckInterval = setInterval(elementLoaded, 100);
  $(window).on('load', elementLoaded);
  document.addEventListener('animationstart', function(event){
    if (event.animationName == 'yotpoNodeInserted'){
      elementLoaded();
    }
  }, true);
}

$$(document).ready(function() {
  hideYotpoWriteReview();
});


// Youtube section
if($$(".container--youtube").length > 0) {
  var tag = document.createElement('script');
      tag.src = "https://youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  var players = [];
  function onYouTubeIframeAPIReady() {
    $('.container--youtube').each(function(i) {
	  var videoId = $(this).data('youtube-id');      
	  var playerId = 'player--' + videoId;
      players[i] = new YT.Player(playerId, {
        'height': '675',
        'width': '1200',
        'videoId': videoId,
        'playerVars': {
          'controls': 1,
          'showinfo': 0,
          'modestbranding': 0,
          'rel': 0
        }
      });             
    });
  }

  $(document).on('opening', '.remodal--youtube', function () {
    debugger;
    $modal = $(this);
    $.each(players, function(i,v) {
      var modalId = $modal.data('remodal-id').replace('modal-youtube--','');
      if (v.playerInfo.videoData.video_id == modalId) {
        v.playVideo(); 
      }
    });  
  });
  $(document).on('closed', '.remodal--youtube', function (e) {
    debugger;
    $modal = $(this);
    $.each(players, function(i,v) {
      var modalId = $modal.data('remodal-id').replace('modal-youtube--','');
      if (v.playerInfo.videoData.video_id == modalId) {
        v.stopVideo(); 
      }
    }); 
  });
}

// Cross sell product
function crossSellProducts() {
  // Slick slider arrows positioning
  slickArrowPosition = function(arrow){
    var arrowPosition = $('.product__cross-sell__img').height() / 2 + 29;
    arrow.css('top', arrowPosition);
  }
  $(window).on('resize', function(){
    slickArrowPosition($('.slick-prev'));
    slickArrowPosition($('.slick-next'));
  });
  $('.product__cross-sell__list').on('init', function(event, slick){
    slickArrowPosition($('.slick-prev'));
    slickArrowPosition($('.slick-next'));
  });
  
  // Slick slider
  $('.product__cross-sell__list').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: $('.product__cross-sell').data('cross-sell-items'),
    slidesToScroll: 1,
    appendArrows: ".product__cross-sell__arrows",
    responsive: [
      {
        breakpoint: 500,
        settings: {
          slidesToShow: $('.product__cross-sell').data('cross-sell-items-mobile'),
        }
      }
    ]
  });
  
  // Cross-sell products
  $('.button--cross-sell-atc').on('click', function(e){
    e.preventDefault();

    var productId = $(this).closest('.cross-sell').data('remodal-id').replace('modal_', '');
    var crossSellItem = $(".product__cross-sell__link[data-cross-sell-id='" + productId + "']"); 
    var crossSellModal = $('[data-remodal-id="modal_'+ productId +'"]');
    var additionalPrice = crossSellItem.data('cross-sell-price');
    var crossSellItemTitlePrice = '<span>' + crossSellItem.find('.product__cross-sell__title').html() + ' (' + slate.Currency.formatMoney(parseInt(additionalPrice), theme.moneyFormat) + ') ' + '</span>';
    var modal = crossSellModal.remodal();
    var productPrice = $('.product__price--main').attr('data-variant-price');
    var additionalTotalPrice = 0;
    var productCrossSellPrice = $('#productCrossSellPrice');

    modal.close();

    var updateMainPrice = function(){
      $('.product__cross-sell__link.active').each(function(){
        var thisPrice = $(this).data('cross-sell-price') * $('[data-remodal-id="' + $(this).data('remodal-target') + '"]').find('.product__qty').val();
        additionalTotalPrice = additionalTotalPrice + thisPrice;
      });
      $('.product__price--main').attr('data-additional-price', additionalTotalPrice);
      $('.product__price--main [data-product-price]').html(slate.Currency.formatMoney(parseInt(productPrice) + parseInt(additionalTotalPrice), theme.moneyFormat));
    }

    if(!crossSellItem.hasClass('active')) {
      crossSellItem.addClass('active');
      crossSellModal.addClass('active');
      $('.product__cross-sell-title').append(crossSellItemTitlePrice);
      
      updateMainPrice();
    } else {
      crossSellItem.removeClass('active');
      crossSellModal.removeClass('active');
      $('.product__cross-sell-title').html($('.product__cross-sell-title').html().replace(crossSellItemTitlePrice, ''));
      
      additionalTotalPrice = 0;
      updateMainPrice();
    }
  });

  // Cross sell quantity
  crossSellQquantityButtons = function(itemId){
    var item = $(".product__quantity[data-cross-sell-id='" + itemId + "']");
    var quantityInput = item.find('.product__qty');
    var quantityPlus = item.find('.product__qtyplus');
    var quantityMinus = item.find('.product__qtyminus');
    
    // This button will increment the value
    quantityPlus.click(function(e){
      e.preventDefault();
  
      var currentVal = parseInt(quantityInput.val());
      var maxVal = parseInt(quantityInput.attr('max'));

      if (maxVal < 0) {
        maxVal = 100;
      }

      if (!isNaN(currentVal)) {
        if(currentVal < maxVal){
          // Increment
          quantityInput.val(currentVal + 1);
        } else {
          // Keep current
          quantityInput.val(currentVal);
        }
      } else {
        // Otherwise put a 1 there
        quantityInput.val(1);
      }
    });
    
    // This button will decrement the value till 1
    quantityMinus.click(function(e) {
      e.preventDefault();

      var currentVal = parseInt(quantityInput.val());

      if (!isNaN(currentVal) && currentVal > 1) {
        // Decrement one
        quantityInput.val(currentVal - 1);
      } else {
        // Otherwise put a 1 there
        quantityInput.val(1);
      }
    });
  };
  $('.cross-sell').each(function(){
    itemId = $(this).data('remodal-id').replace('modal_', '');
    crossSellQquantityButtons(itemId);
  });

  // Add cross-sell to the cart
  $('.button--add-to-cart').on('click', function(e){
    e.preventDefault();

    $('.product__cross-sell__link.active').each(function(){
      var crossSellProduct = $(this).attr('data-cross-sell-id');
      var crossSellQty = $('[data-remodal-id="modal_'+ crossSellProduct +'"]').find('.product__qty').val();

      CartJS.addItem(crossSellProduct, crossSellQty);
    });
  });

  // Cross sell products sliders
  $(document).on('opening', '.cross-sell__modal', function () {
    $(this).find('.product-slider-for').show().slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      dots: false,
      arrows: true,
      fade: true,
      asNavFor: $(this).find('.product-slider-nav')
    });
    $(this).find('.product-slider-nav').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: $(this).find('.product-slider-for'),
      dots: false,
      infinite: false,
      focusOnSelect: true
    });
  });
  $(document).on('closed', '.cross-sell__modal', function () {
    $(this).find('.product-slider-for').slick('unslick');
    // $(this).find('.product-slider-nav').slick('unslick');
  });
}
$(document).ready(function(){
  if($$('.cross-sell').length > 0) {
    crossSellProducts();
  }
});


// Home page featured collections carousel
$$(document).ready(function() {
  if($$("#homePageFeaturedCollections").length > 0) {
    $$('#homePageFeaturedCollections').slick({
      lazyLoad: 'progressive',
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
	  prevArrow: '<button type="button" class="slick-arrow slick-arrow--prev" style="display: block;"><svg height="100px" width="100px"  fill="#d6d6d6" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" version="1.1" x="0px" y="0px" viewBox="0 0 36 36"><g transform="translate(0,-1016.3622)"><path style="text-indent:0;text-transform:none;direction:ltr;block-progression:tb;baseline-shift:baseline;color:#000000;enable-background:accumulate;" d="m 24,1034.3622 c -3.5,-4.3333 -6.9375,-8.6667 -10.4375,-13 l -1.5625,1.2381 9.5,11.7619 -9.5,11.7619 1.5625,1.2381 c 3.5,-4.3333 6.9375,-8.6667 10.4375,-13 z" fill="#d6d6d6" fill-opacity="1" stroke="none" marker="none" visibility="visible" display="inline" overflow="visible"></path></g></svg><span class="visually-hidden">Previous</span></button>',
      nextArrow: '<button type="button" class="slick-arrow slick-arrow--next" style="display: block;"><svg height="100px" width="100px"  fill="#d6d6d6" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" version="1.1" x="0px" y="0px" viewBox="0 0 36 36"><g transform="translate(0,-1016.3622)"><path style="text-indent:0;text-transform:none;direction:ltr;block-progression:tb;baseline-shift:baseline;color:#000000;enable-background:accumulate;" d="m 24,1034.3622 c -3.5,-4.3333 -6.9375,-8.6667 -10.4375,-13 l -1.5625,1.2381 9.5,11.7619 -9.5,11.7619 1.5625,1.2381 c 3.5,-4.3333 6.9375,-8.6667 10.4375,-13 z" fill="#d6d6d6" fill-opacity="1" stroke="none" marker="none" visibility="visible" display="inline" overflow="visible"></path></g></svg><span class="visually-hidden">Next</span></button>',   
      infinite: false,
      responsive: [
        {
          breakpoint: 850,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1.25,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
  $('.slider-item__link').on('mouseenter', function(){
    $(this).prev('.slider-item__text').find('.button').addClass('hover')
  });
  $('.slider-item__link').on('mouseleave', function(){
    $(this).prev('.slider-item__text').find('.button').removeClass('hover')
  });  
});

// Home page testimonials carousel
$$(document).ready(function() {
  if($$("#homePageTestimonials").length > 0) {
    $$('#homePageTestimonials').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: true,
      //fade: true,
      //cssEase: 'linear',
	  prevArrow: '<button type="button" class="slick-arrow slick-arrow--prev" style="display: block;"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-left" viewBox="0 0 9.2 17.2"><path d="M9 16c.3.3.3.7 0 1s-.7.3-1 0L.2 9.1c-.3-.3-.3-.7 0-1L8 .2c.3-.3.7-.3 1 0 .3.3.3.7 0 1L1.9 8.6 9 16z"></path></svg><span class="visually-hidden">Previous</span></button>',
      nextArrow: '<button type="button" class="slick-arrow slick-arrow--next" style="display: block;"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-right" viewBox="0 0 9.2 17.2"><path d="M7.3 8.6L.2 1.2C-.1.9-.1.5.2.2c.3-.3.7-.3 1 0L9 8.1c.3.3.3.7 0 1L1.2 17c-.3.3-.7.3-1 0-.3-.3-.3-.7 0-1l7.1-7.4z"></path></svg><span class="visually-hidden">Next</span></button>',   
    });
  }
});

// Home page trending carousel
$$(document).ready(function() {
  if($$("#homePageTrending").length > 0) {
    $$('#homePageTrending').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
	  prevArrow: '<button type="button" class="slick-arrow slick-arrow--prev" style="display: block;"><svg height="100px" width="100px"  fill="#d6d6d6" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" version="1.1" x="0px" y="0px" viewBox="0 0 36 36"><g transform="translate(0,-1016.3622)"><path style="text-indent:0;text-transform:none;direction:ltr;block-progression:tb;baseline-shift:baseline;color:#000000;enable-background:accumulate;" d="m 24,1034.3622 c -3.5,-4.3333 -6.9375,-8.6667 -10.4375,-13 l -1.5625,1.2381 9.5,11.7619 -9.5,11.7619 1.5625,1.2381 c 3.5,-4.3333 6.9375,-8.6667 10.4375,-13 z" fill="#d6d6d6" fill-opacity="1" stroke="none" marker="none" visibility="visible" display="inline" overflow="visible"></path></g></svg><span class="visually-hidden">Previous</span></button>',
      nextArrow: '<button type="button" class="slick-arrow slick-arrow--next" style="display: block;"><svg height="100px" width="100px"  fill="#d6d6d6" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" version="1.1" x="0px" y="0px" viewBox="0 0 36 36"><g transform="translate(0,-1016.3622)"><path style="text-indent:0;text-transform:none;direction:ltr;block-progression:tb;baseline-shift:baseline;color:#000000;enable-background:accumulate;" d="m 24,1034.3622 c -3.5,-4.3333 -6.9375,-8.6667 -10.4375,-13 l -1.5625,1.2381 9.5,11.7619 -9.5,11.7619 1.5625,1.2381 c 3.5,-4.3333 6.9375,-8.6667 10.4375,-13 z" fill="#d6d6d6" fill-opacity="1" stroke="none" marker="none" visibility="visible" display="inline" overflow="visible"></path></g></svg><span class="visually-hidden">Next</span></button>',   
      responsive: [
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
});

// Header advanced mega menu
$(document).ready(function() {
  if($(".has-dropdown--advanced").length > 0) {
    $('.child-level-item-title').on('mouseover', function(){
      $('.child-level-item').removeClass('active');
      $(this).closest('.child-level-item').addClass('active');
    })
  }
  
  $('.child-level-item-title').on('mouseover', function(){
    //debugger;
    $('.child-level-item').removeClass('active');
    $(this).closest('.child-level-item').addClass('active');
    
    var menuHeight = $(this).parents('.site-nav__children').outerHeight();
    var borderHeight = menuHeight - 40;
    
    $(this).next('.site-nav__grand-children').css({'min-height': menuHeight});
    $(this).next('.site-nav__grand-children').find('ul').css({'min-height': borderHeight});
  })  
});
